/*! @ciancoders/thermal-print — MIT */
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.js
var src_exports = {};
__export(src_exports, {
  ALIGN: () => ALIGN,
  BAUD_RATES: () => BAUD_RATES,
  BleTransport: () => BleTransport,
  CAT_MODELS: () => CAT_MODELS,
  CAT_NOTIFY: () => CAT_NOTIFY,
  CAT_SERVICE: () => CAT_SERVICE,
  CAT_WRITE: () => CAT_WRITE,
  CHUNK_SIZES: () => CHUNK_SIZES,
  CODEPAGES: () => CODEPAGES,
  COLUMNS: () => COLUMNS,
  DEFAULT_CODEPAGE: () => DEFAULT_CODEPAGE,
  DEFAULT_PROFILE: () => DEFAULT_PROFILE,
  DOC_VERSION: () => DOC_VERSION,
  DOTS: () => DOTS,
  Emitter: () => Emitter,
  EscPos: () => EscPos,
  KNOWN_PRINTER_SERVICES: () => KNOWN_PRINTER_SERVICES,
  NODE_TYPES: () => NODE_TYPES,
  PROFILES: () => PROFILES,
  Printer: () => Printer,
  SYMBOLOGIES: () => SYMBOLOGIES,
  SerialTransport: () => SerialTransport,
  alignText: () => alignText,
  barcodePixmap: () => barcodePixmap,
  blit: () => blit,
  buildCatFeed: () => buildCatFeed,
  buildCatJob: () => buildCatJob,
  canRasterize: () => canRasterize,
  center: () => center,
  chunkBytes: () => chunkBytes,
  composeRaster: () => composeRaster,
  concatBytes: () => concatBytes,
  createDocument: () => createDocument,
  createPixmap: () => createPixmap,
  defineProfile: () => defineProfile,
  describeDeviceState: () => describeDeviceState,
  detectProfile: () => detectProfile,
  distribute: () => distribute,
  divider: () => divider,
  encodeCode128: () => encodeCode128,
  encodeQr: () => encodeQr,
  encodeText: () => encodeText,
  expandUuid: () => expandUuid,
  hexDump: () => hexDump,
  inkRatio: () => inkRatio,
  isCode128Compatible: () => isCode128Compatible,
  layoutPair: () => layoutPair,
  layoutRow: () => layoutRow,
  listProfiles: () => listProfiles,
  loadPixmap: () => loadPixmap,
  looksLikeCatPrinter: () => looksLikeCatPrinter,
  normalizeDocument: () => normalizeDocument,
  offsetFor: () => offsetFor,
  packLsbFirstRows: () => packLsbFirstRows,
  packMsbFirst: () => packMsbFirst,
  padLine: () => padLine,
  padTo: () => padTo,
  parseDeviceState: () => parseDeviceState,
  parseHex: () => parseHex,
  pixmapToRgba: () => pixmapToRgba,
  qrCapacityBytes: () => qrCapacityBytes,
  qrPixmap: () => qrPixmap,
  renderEscPos: () => renderEscPos,
  renderRaster: () => renderRaster,
  renderText: () => renderText,
  resolveProfile: () => resolveProfile,
  rgbaToPixmap: () => rgbaToPixmap,
  setCanvasFactory: () => setCanvasFactory,
  setQrEncoder: () => setQrEncoder,
  toBytes: () => toBytes,
  wrapText: () => wrapText
});
module.exports = __toCommonJS(src_exports);

// src/emitter.js
var Emitter = class {
  constructor() {
    this._handlers = /* @__PURE__ */ new Map();
  }
  /**
   * @param {string} event
   * @param {Function} handler
   * @returns {() => void} función para darse de baja
   */
  on(event, handler) {
    if (!this._handlers.has(event)) this._handlers.set(event, /* @__PURE__ */ new Set());
    this._handlers.get(event).add(handler);
    return () => this.off(event, handler);
  }
  once(event, handler) {
    const off = this.on(event, (...args) => {
      off();
      handler(...args);
    });
    return off;
  }
  off(event, handler) {
    var _a;
    (_a = this._handlers.get(event)) == null ? void 0 : _a.delete(handler);
  }
  emit(event, payload) {
    var _a, _b;
    for (const handler of [...(_a = this._handlers.get(event)) != null ? _a : []]) {
      try {
        handler(payload);
      } catch (err) {
        if (event !== "error") this.emit("error", err);
      }
    }
    if (event !== "*") {
      for (const handler of [...(_b = this._handlers.get("*")) != null ? _b : []]) {
        try {
          handler({ event, payload });
        } catch (e) {
        }
      }
    }
  }
  removeAllListeners(event) {
    if (event) this._handlers.delete(event);
    else this._handlers.clear();
  }
};

// src/doc.js
var DOC_VERSION = 1;
var NODE_TYPES = [
  "text",
  "row",
  "columns",
  "table",
  "rule",
  "space",
  "qr",
  "barcode",
  "image",
  "cut",
  "pulse",
  "raw",
  "group"
];
var ALIGNMENTS = ["left", "center", "right"];
function fail(message, path) {
  const err = new Error(path ? `${path}: ${message}` : message);
  err.name = "ThermalPrintDocumentError";
  return err;
}
function normalizeStyle(style, path) {
  if (style == null) return void 0;
  if (typeof style !== "object") throw fail("style debe ser un objeto", path);
  const out = {};
  if (style.bold != null) out.bold = !!style.bold;
  if (style.invert != null) out.invert = !!style.invert;
  if (style.underline != null) {
    const u = Number(style.underline);
    if (u !== 0 && u !== 1 && u !== 2) {
      throw fail("style.underline debe ser 0, 1 o 2", path);
    }
    out.underline = u;
  }
  return Object.keys(out).length ? out : void 0;
}
function normalizeSize(size, path) {
  var _a, _b;
  if (size == null) return void 0;
  if (typeof size === "number") return { w: clampScale(size, path), h: clampScale(size, path) };
  if (typeof size !== "object") throw fail("size debe ser un n\xFAmero o {w, h}", path);
  return {
    w: clampScale((_a = size.w) != null ? _a : 1, path),
    h: clampScale((_b = size.h) != null ? _b : 1, path)
  };
}
function clampScale(n, path) {
  const v = Math.floor(Number(n));
  if (!Number.isFinite(v) || v < 1 || v > 8) {
    throw fail("los multiplicadores de size van de 1 a 8", path);
  }
  return v;
}
function normalizeAlign(align, path) {
  if (align == null) return void 0;
  if (!ALIGNMENTS.includes(align)) {
    throw fail(`align debe ser ${ALIGNMENTS.join(", ")}`, path);
  }
  return align;
}
function inherit(child, parent) {
  var _a;
  if (!parent) return child;
  const out = { ...child };
  if (out.align === void 0 && parent.align !== void 0) out.align = parent.align;
  if (out.font === void 0 && parent.font !== void 0) out.font = parent.font;
  if (out.size === void 0 && parent.size !== void 0) out.size = parent.size;
  if (parent.style) out.style = { ...parent.style, ...(_a = out.style) != null ? _a : {} };
  return out;
}
function normalizeCell(cell, path) {
  const c = typeof cell === "object" && cell !== null ? cell : { value: cell };
  const out = { value: c.value == null ? "" : String(c.value) };
  if (c.width != null) {
    const w = Number(c.width);
    if (!Number.isFinite(w) || w <= 0) throw fail("width debe ser un n\xFAmero > 0", path);
    out.width = w;
  }
  const align = normalizeAlign(c.align, path);
  if (align) out.align = align;
  if (c.wrap === false) out.wrap = false;
  const style = normalizeStyle(c.style, path);
  if (style) out.style = style;
  return out;
}
function normalizeNode(node, path, inherited) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
  if (node == null) return [];
  const raw = typeof node === "string" ? { type: "text", value: node } : node;
  if (typeof raw !== "object") throw fail("nodo no reconocido", path);
  const type = raw.type;
  if (!NODE_TYPES.includes(type)) {
    throw fail(`type "${type}" desconocido (v\xE1lidos: ${NODE_TYPES.join(", ")})`, path);
  }
  const base = inherit({
    type,
    align: normalizeAlign(raw.align, path),
    style: normalizeStyle(raw.style, path),
    size: normalizeSize(raw.size, path),
    font: raw.font
  }, inherited);
  switch (type) {
    case "group": {
      const children = Array.isArray(raw.children) ? raw.children : [];
      return children.flatMap((child, i) => normalizeNode(child, `${path}.children[${i}]`, base));
    }
    case "text":
      return [{
        ...base,
        value: raw.value == null ? "" : String(raw.value),
        wrap: raw.wrap !== false
      }];
    case "row": {
      const left = normalizeCell((_a = raw.left) != null ? _a : "", `${path}.left`);
      const right = normalizeCell(
        typeof raw.right === "object" && raw.right !== null ? raw.right : { value: (_b = raw.right) != null ? _b : "", align: "right" },
        `${path}.right`
      );
      if (right.align == null) right.align = "right";
      return [{
        ...base,
        type: "row",
        left,
        right,
        gap: raw.gap == null ? 1 : Math.max(1, Math.floor(raw.gap))
      }];
    }
    case "columns": {
      if (!Array.isArray(raw.cells) || !raw.cells.length) {
        throw fail("columns necesita un array cells no vac\xEDo", path);
      }
      return [{
        ...base,
        cells: raw.cells.map((c, i) => normalizeCell(c, `${path}.cells[${i}]`)),
        gap: raw.gap == null ? 1 : Math.max(0, Math.floor(raw.gap))
      }];
    }
    case "table": {
      if (!Array.isArray(raw.rows)) throw fail("table necesita un array rows", path);
      const columns = ((_c = raw.columns) != null ? _c : []).map((c, i) => normalizeCell(c, `${path}.columns[${i}]`));
      return [{
        ...base,
        columns,
        header: raw.header == null ? null : raw.header.map((c, i) => normalizeCell(c, `${path}.header[${i}]`)),
        rows: raw.rows.map((row, r) => {
          if (!Array.isArray(row)) throw fail("cada fila de table debe ser un array", `${path}.rows[${r}]`);
          return row.map((c, i) => normalizeCell(c, `${path}.rows[${r}][${i}]`));
        }),
        gap: raw.gap == null ? 1 : Math.max(0, Math.floor(raw.gap))
      }];
    }
    case "rule":
      return [{
        ...base,
        char: String((_d = raw.char) != null ? _d : "-")[0] || "-",
        thickness: Math.max(1, Math.floor(Number((_e = raw.thickness) != null ? _e : 1)))
      }];
    case "space":
      return [{ ...base, lines: Math.max(0, Math.floor(Number((_f = raw.lines) != null ? _f : 1))) }];
    case "qr": {
      if (raw.value == null || String(raw.value) === "") {
        throw fail("qr necesita un value no vac\xEDo", path);
      }
      const ecc = (_g = raw.ecc) != null ? _g : "M";
      if (!["L", "M", "Q", "H"].includes(ecc)) throw fail("qr.ecc debe ser L, M, Q o H", path);
      return [{
        ...base,
        value: String(raw.value),
        ecc,
        // 1-16 en ESC/POS es el tamaño de módulo en puntos; en raster se usa
        // igual, así que el QR sale del mismo tamaño físico en ambos.
        size: Math.min(16, Math.max(1, Math.floor(Number((_i = (_h = raw.moduleSize) != null ? _h : raw.size) != null ? _i : 6)))),
        align: (_j = base.align) != null ? _j : "center"
      }];
    }
    case "barcode": {
      if (raw.value == null || String(raw.value) === "") {
        throw fail("barcode necesita un value no vac\xEDo", path);
      }
      return [{
        ...base,
        value: String(raw.value),
        symbology: (_k = raw.symbology) != null ? _k : "code128",
        height: Math.max(1, Math.floor(Number((_l = raw.height) != null ? _l : 60))),
        moduleWidth: Math.min(6, Math.max(1, Math.floor(Number((_m = raw.moduleWidth) != null ? _m : 2)))),
        // 0 nada, 1 arriba, 2 abajo, 3 ambos
        hri: [0, 1, 2, 3].includes(raw.hri) ? raw.hri : 2,
        align: (_n = base.align) != null ? _n : "center"
      }];
    }
    case "image": {
      if (raw.source == null) throw fail("image necesita un source", path);
      return [{
        ...base,
        source: raw.source,
        width: raw.width == null ? null : Number(raw.width),
        dither: (_o = raw.dither) != null ? _o : "floyd",
        threshold: Number((_p = raw.threshold) != null ? _p : 128),
        align: (_q = base.align) != null ? _q : "center"
      }];
    }
    case "cut":
      return [{ ...base, partial: !!raw.partial }];
    case "pulse":
      return [{ ...base, pin: raw.pin === 1 ? 1 : 0 }];
    case "raw":
      return [{ ...base, escpos: (_r = raw.escpos) != null ? _r : null, cat: (_s = raw.cat) != null ? _s : null }];
    default:
      return [];
  }
}
var NORMALIZED = "__thermalPrintNormalized";
function isNormalized(doc) {
  return !!doc && doc[NORMALIZED] === true;
}
function normalizeDocument(doc) {
  var _a, _b, _c, _d, _e, _f, _g;
  if (!doc || typeof doc !== "object") throw fail("el documento debe ser un objeto");
  if (isNormalized(doc)) return doc;
  const body = (_b = (_a = doc.body) != null ? _a : doc.content) != null ? _b : doc.nodes;
  if (!Array.isArray(body)) throw fail("el documento necesita un array body");
  const defaults = (_c = doc.defaults) != null ? _c : {};
  return {
    [NORMALIZED]: true,
    v: Number((_d = doc.v) != null ? _d : DOC_VERSION),
    meta: { ...(_e = doc.meta) != null ? _e : {} },
    defaults: {
      // Pistas, no órdenes: un perfil puede ignorarlas si su impresora no puede.
      codepage: (_f = defaults.codepage) != null ? _f : null,
      columns: defaults.columns == null ? null : Math.max(8, Math.floor(defaults.columns)),
      font: (_g = defaults.font) != null ? _g : null,
      feedAfter: defaults.feedAfter == null ? null : Math.max(0, Math.floor(defaults.feedAfter)),
      cut: defaults.cut == null ? null : !!defaults.cut
    },
    body: body.flatMap((node, i) => normalizeNode(node, `body[${i}]`, null))
  };
}
function createDocument(options = {}) {
  var _a, _b;
  const body = [];
  const meta = (_a = options.meta) != null ? _a : {};
  const defaults = (_b = options.defaults) != null ? _b : {};
  const api = {
    /** Añade un nodo ya construido (o cualquier objeto con `type`). */
    push(...nodes) {
      body.push(...nodes.flat());
      return api;
    },
    text(value, opts = {}) {
      return api.push({ type: "text", value, ...opts });
    },
    row(left, right, opts = {}) {
      return api.push({ type: "row", left, right, ...opts });
    },
    columns(cells, opts = {}) {
      return api.push({ type: "columns", cells, ...opts });
    },
    table(spec) {
      return api.push({ type: "table", ...spec });
    },
    rule(char = "-", opts = {}) {
      return api.push({ type: "rule", char, ...opts });
    },
    space(lines = 1) {
      return api.push({ type: "space", lines });
    },
    qr(value, opts = {}) {
      return api.push({ type: "qr", value, ...opts });
    },
    barcode(value, opts = {}) {
      return api.push({ type: "barcode", value, ...opts });
    },
    image(source, opts = {}) {
      return api.push({ type: "image", source, ...opts });
    },
    cut(partial = false) {
      return api.push({ type: "cut", partial });
    },
    pulse(pin = 0) {
      return api.push({ type: "pulse", pin });
    },
    raw(bytes) {
      return api.push({ type: "raw", ...bytes });
    },
    /** Agrupa nodos bajo un estilo común; se aplana al normalizar. */
    group(opts, build) {
      const inner = createDocument();
      build(inner);
      return api.push({ type: "group", ...opts, children: inner.build().body });
    },
    /** Documento plano, listo para `printer.print()` o para serializar a JSON. */
    build() {
      return { v: DOC_VERSION, meta, defaults, body };
    }
  };
  return api;
}

// src/layout.js
function padLine(left, right, cols) {
  const l = String(left != null ? left : "");
  const r = String(right != null ? right : "");
  const gap = cols - l.length - r.length;
  if (gap >= 1) return l + " ".repeat(gap) + r;
  const room = Math.max(0, cols - r.length - 1);
  return `${l.slice(0, room)} ${r}`;
}
function center(text, cols) {
  const t = String(text != null ? text : "").slice(0, cols);
  const pad = Math.max(0, Math.floor((cols - t.length) / 2));
  return " ".repeat(pad) + t;
}
function alignText(text, cols, align = "left") {
  const t = String(text != null ? text : "").slice(0, cols);
  if (align === "center") return center(t, cols);
  if (align === "right") return " ".repeat(Math.max(0, cols - t.length)) + t;
  return t;
}
function padTo(text, cols, align = "left") {
  const t = alignText(text, cols, align);
  return t.length >= cols ? t.slice(0, cols) : t + " ".repeat(cols - t.length);
}
function divider(cols, ch = "-") {
  const c = String(ch || "-")[0];
  return c.repeat(Math.max(0, cols));
}
function wrapText(text, cols) {
  if (cols < 1) return [String(text != null ? text : "")];
  const lines = [];
  for (const paragraph of String(text != null ? text : "").split("\n")) {
    if (paragraph.length <= cols) {
      lines.push(paragraph);
      continue;
    }
    let current = "";
    for (const word of paragraph.split(/\s+/)) {
      if (!current.length) {
        current = word;
      } else if (current.length + 1 + word.length <= cols) {
        current += ` ${word}`;
      } else {
        lines.push(current);
        current = word;
      }
      while (current.length > cols) {
        lines.push(current.slice(0, cols));
        current = current.slice(cols);
      }
    }
    if (current.length) lines.push(current);
  }
  return lines.length ? lines : [""];
}
function distribute(cells, total) {
  const out = new Array(cells.length).fill(0);
  const flexible = [];
  let used = 0;
  cells.forEach((cell, i) => {
    const w = cell == null ? void 0 : cell.width;
    if (typeof w === "number" && w > 0) {
      const cols = w < 1 ? Math.floor(total * w) : Math.floor(w);
      out[i] = Math.max(1, cols);
      used += out[i];
    } else {
      flexible.push(i);
    }
  });
  const remaining = total - used;
  if (!flexible.length) {
    if (used > total && used > 0) {
      const factor = total / used;
      let acc = 0;
      for (let i = 0; i < out.length; i++) {
        out[i] = Math.max(1, Math.floor(out[i] * factor));
        acc += out[i];
      }
      for (let i = out.length - 1; i >= 0 && acc < total; i--) {
        out[i]++;
        acc++;
      }
    }
    return out;
  }
  if (remaining < flexible.length) {
    let deficit = flexible.length - Math.max(0, remaining);
    const order = out.map((cols, i) => ({ cols, i })).filter(({ i }) => !flexible.includes(i)).sort((a, b) => b.cols - a.cols);
    let guard = 0;
    while (deficit > 0 && order.length && guard++ < 1e3) {
      for (const entry of order) {
        if (deficit <= 0) break;
        if (out[entry.i] > 1) {
          out[entry.i]--;
          deficit--;
        }
      }
      if (order.every(({ i }) => out[i] <= 1)) break;
    }
  }
  const left = Math.max(0, total - out.reduce((n, c) => n + c, 0));
  const base = Math.floor(left / flexible.length);
  let extra = left - base * flexible.length;
  for (const i of flexible) {
    out[i] = base + (extra > 0 ? 1 : 0);
    if (extra > 0) extra--;
  }
  return out;
}
function layoutRow(cells, cols, opts = {}) {
  var _a;
  const list = cells != null ? cells : [];
  if (!list.length) return [""];
  const gap = Math.max(0, (_a = opts.gap) != null ? _a : 1);
  const gaps = gap * (list.length - 1);
  const widths = distribute(list, Math.max(list.length, cols - gaps));
  const blocks = list.map((cell, i) => {
    var _a2;
    const w = widths[i];
    const text = String((_a2 = cell == null ? void 0 : cell.value) != null ? _a2 : "");
    const lines = (cell == null ? void 0 : cell.wrap) === false ? [text.slice(0, w)] : wrapText(text, w);
    return lines.map((l) => {
      var _a3;
      return padTo(l, w, (_a3 = cell == null ? void 0 : cell.align) != null ? _a3 : "left");
    });
  });
  const height = Math.max(...blocks.map((b) => b.length));
  const out = [];
  for (let row = 0; row < height; row++) {
    const parts = blocks.map((block, i) => {
      var _a2;
      return (_a2 = block[row]) != null ? _a2 : " ".repeat(widths[i]);
    });
    out.push(parts.join(" ".repeat(gap)).trimEnd());
  }
  return out;
}
function layoutPair(left, right, cols, gap = 1) {
  var _a, _b, _c, _d;
  const l = String((_a = left == null ? void 0 : left.value) != null ? _a : "");
  const r = String((_b = right == null ? void 0 : right.value) != null ? _b : "");
  if (!r.length) return wrapText(l, cols);
  if (!l.length) return [alignText(r.slice(0, cols), cols, (_c = right == null ? void 0 : right.align) != null ? _c : "right")];
  if (l.length + gap + r.length <= cols) {
    return [padLine(l, r, cols)];
  }
  const out = wrapText(l, cols);
  if (r.length <= cols) {
    out.push(alignText(r, cols, (_d = right == null ? void 0 : right.align) != null ? _d : "right"));
  } else {
    out.push(...wrapText(r, cols));
  }
  return out;
}
var COLUMNS = {
  58: { A: 32, B: 42 },
  80: { A: 48, B: 64 }
};
var DOTS = { 58: 384, 80: 576 };

// src/protocol/cat.js
var CAT_SERVICE = "0000ae30-0000-1000-8000-00805f9b34fb";
var CAT_WRITE = "0000ae01-0000-1000-8000-00805f9b34fb";
var CAT_NOTIFY = "0000ae02-0000-1000-8000-00805f9b34fb";
var CAT_MODELS = [
  "GB01",
  "GB02",
  "GB03",
  "GT01",
  "YT01",
  "MX05",
  "MX06",
  "MX08",
  "MX09",
  "MX10",
  "MXTP",
  "X5"
];
var CRC8_TABLE = (() => {
  const table = new Uint8Array(256);
  for (let i = 0; i < 256; i++) {
    let crc = i;
    for (let bit2 = 0; bit2 < 8; bit2++) {
      crc = crc & 128 ? (crc << 1 ^ 7) & 255 : crc << 1 & 255;
    }
    table[i] = crc;
  }
  return table;
})();
function crc8(bytes) {
  let crc = 0;
  for (const b of bytes) crc = CRC8_TABLE[(crc ^ b) & 255];
  return crc;
}
function frame(opcode, payload = [], prefix = []) {
  const data = payload instanceof Uint8Array ? payload : Uint8Array.from(payload);
  const out = new Uint8Array(prefix.length + 8 + data.length);
  let i = 0;
  for (const b of prefix) out[i++] = b;
  out[i++] = 81;
  out[i++] = 120;
  out[i++] = opcode;
  out[i++] = 0;
  out[i++] = data.length & 255;
  out[i++] = data.length >> 8 & 255;
  out.set(data, i);
  i += data.length;
  out[i++] = crc8(data);
  out[i++] = 255;
  return out;
}
var u16le = (n) => [n & 255, n >> 8 & 255];
var CMD = {
  RETRACT_PAPER: 160,
  FEED_PAPER: 161,
  DRAW_BITMAP: 162,
  DEVICE_STATE: 163,
  SET_QUALITY: 164,
  LATTICE: 166,
  DEVICE_INFO: 168,
  UPDATE_DEVICE: 169,
  FLOW_CONTROL: 174,
  SET_ENERGY: 175,
  SET_SPEED: 189,
  APPLY_ENERGY: 190
};
var LATTICE_START = [170, 85, 23, 56, 68, 95, 95, 95, 68, 56, 44];
var LATTICE_END = [170, 85, 23, 0, 0, 0, 0, 0, 0, 0, 23];
var cat = {
  deviceState: () => frame(CMD.DEVICE_STATE, [0]),
  deviceInfo: () => frame(CMD.DEVICE_INFO, [0]),
  updateDevice: () => frame(CMD.UPDATE_DEVICE, [0]),
  /** No hay equivalente a ESC t; esto fija 200 dpi (0x32 = 50). */
  setDpi200: () => frame(CMD.SET_QUALITY, [50]),
  setSpeed: (v) => frame(CMD.SET_SPEED, [v & 255]),
  setEnergy: (v) => frame(CMD.SET_ENERGY, u16le(v)),
  applyEnergy: () => frame(CMD.APPLY_ENERGY, [1]),
  startLattice: () => frame(CMD.LATTICE, LATTICE_START),
  endLattice: () => frame(CMD.LATTICE, LATTICE_END),
  drawBitmap: (rowBytes) => frame(CMD.DRAW_BITMAP, rowBytes),
  feedPaper: (n) => frame(CMD.FEED_PAPER, u16le(n)),
  retractPaper: (n) => frame(CMD.RETRACT_PAPER, u16le(n)),
  /**
   * Handshake de inicio. Algunos modelos quieren la variante "new", que es la
   * misma trama con un 0x12 delante. No hay forma fiable de saber cuál necesita
   * cada rebrand, así que es un ajuste del perfil (`raster.startNew`).
   */
  startPrinting: (useNew = false) => useNew ? frame(CMD.DEVICE_STATE, [0], [18]) : frame(CMD.DEVICE_STATE, [0]),
  /** Control de flujo: normalmente lo envía la impresora; aquí para pruebas. */
  pause: () => frame(CMD.FLOW_CONTROL, [16]),
  resume: () => frame(CMD.FLOW_CONTROL, [0])
};
var DEFAULT_CAT_OPTS = {
  energy: 12e3,
  speed: 32,
  feedDots: 128,
  startNew: false
};
function buildCatJob(rows, opts = {}) {
  const o = { ...DEFAULT_CAT_OPTS, ...opts };
  const parts = [
    cat.deviceState(),
    cat.startPrinting(o.startNew),
    cat.setDpi200(),
    cat.setSpeed(o.speed),
    cat.setEnergy(o.energy),
    cat.applyEnergy(),
    cat.updateDevice(),
    cat.startLattice()
  ];
  for (const row of rows) parts.push(cat.drawBitmap(row));
  parts.push(cat.endLattice());
  if (o.feedDots > 0) parts.push(cat.feedPaper(o.feedDots));
  return concat(parts);
}
function buildCatFeed(dots = 64) {
  return concat([cat.deviceState(), cat.feedPaper(dots)]);
}
function concat(parts) {
  const total = parts.reduce((n, p) => n + p.length, 0);
  const out = new Uint8Array(total);
  let offset = 0;
  for (const p of parts) {
    out.set(p, offset);
    offset += p.length;
  }
  return out;
}
function parseDeviceState(bytes) {
  if (bytes.length < 8 || bytes[0] !== 81 || bytes[1] !== 120) {
    return { ok: false, raw: bytes };
  }
  const opcode = bytes[2];
  const len = bytes[4] | bytes[5] << 8;
  const data = bytes.subarray(6, 6 + len);
  if (opcode !== CMD.DEVICE_STATE || !data.length) {
    return { ok: true, opcode, data };
  }
  const flags = data[0];
  return {
    ok: true,
    opcode,
    flags,
    noPaper: !!(flags & 1),
    coverOpen: !!(flags & 2),
    overheated: !!(flags & 4),
    lowBattery: !!(flags & 8),
    busy: !!(flags & 128)
  };
}
function describeDeviceState(state) {
  if (!(state == null ? void 0 : state.ok) || state.flags === void 0) return null;
  const flags = [];
  if (state.noPaper) flags.push("sin papel");
  if (state.coverOpen) flags.push("tapa abierta");
  if (state.overheated) flags.push("cabezal caliente");
  if (state.lowBattery) flags.push("bater\xEDa baja");
  if (state.busy) flags.push("ocupada");
  return flags.length ? flags.join(", ") : "lista";
}
function looksLikeCatPrinter(tree) {
  return (tree != null ? tree : []).some((s) => s.service === CAT_SERVICE);
}

// src/profiles.js
var ESCPOS_CAPS = {
  nativeQr: true,
  nativeBarcode: true,
  textStyles: true,
  // negrita, subrayado, inverso, multiplicadores
  fonts: true,
  // fuente A / B
  image: true,
  // GS v 0
  cut: true,
  drawer: true,
  codepage: true
};
var CAT_CAPS = {
  nativeQr: false,
  nativeBarcode: false,
  textStyles: false,
  // se emulan dibujando
  fonts: false,
  image: true,
  // es lo único que sabe hacer
  cut: false,
  // no llevan cuchilla
  drawer: false,
  codepage: false
  // el texto son píxeles: no hay problema de codificación
};
var PROFILES = {
  "escpos-58": {
    id: "escpos-58",
    label: "ESC/POS 58 mm (Zjiang, Xprinter, Goojprt, Munbyn\u2026)",
    renderer: "escpos",
    paperWidth: "58",
    dots: DOTS[58],
    columns: COLUMNS[58].A,
    font: "A",
    codepage: "CP850",
    capabilities: { ...ESCPOS_CAPS },
    transport: { chunkSize: 20, delayMs: 20, withResponse: true },
    feedAfter: 4,
    cut: true
  },
  "escpos-80": {
    id: "escpos-80",
    label: "ESC/POS 80 mm (impresoras de mostrador)",
    renderer: "escpos",
    paperWidth: "80",
    dots: DOTS[80],
    columns: COLUMNS[80].A,
    font: "A",
    codepage: "CP850",
    capabilities: { ...ESCPOS_CAPS },
    transport: { chunkSize: 64, delayMs: 10, withResponse: true },
    feedAfter: 4,
    cut: true
  },
  "cat-58": {
    id: "cat-58",
    label: "Cat printer 58 mm (GB01/02/03, GT01, YT01, MX05-MX10, MMN\u2026)",
    renderer: "raster",
    paperWidth: "58",
    dots: 384,
    columns: 32,
    font: "A",
    codepage: null,
    capabilities: { ...CAT_CAPS },
    // ae01 suele ser «write without response»; el cliente de referencia usa
    // bloques de ~200 bytes, y 128 va sobrado y sobrevive a MTU pequeños.
    transport: { chunkSize: 128, delayMs: 20, withResponse: false },
    feedAfter: 0,
    // el avance lo hace el propio trabajo cat, en puntos
    cut: false,
    raster: {
      energy: 12e3,
      // GB01 admite 8000 / 12000 / 17500
      speed: 32,
      feedDots: 128,
      startNew: false,
      // handshake con prefijo 0x12 en algunos rebrands
      dither: "floyd",
      threshold: 128,
      margin: 6
    }
  },
  /**
   * ESC/POS que no traen generador de QR ni de códigos de barras. Existen: los
   * clones más baratos aceptan GS ( k sin protestar y no imprimen nada. Con
   * este perfil los códigos se dibujan como imagen raster.
   */
  "escpos-58-noqr": {
    id: "escpos-58-noqr",
    label: "ESC/POS 58 mm sin QR nativo (clones b\xE1sicos)",
    renderer: "escpos",
    paperWidth: "58",
    dots: DOTS[58],
    columns: COLUMNS[58].A,
    font: "A",
    codepage: "CP850",
    capabilities: { ...ESCPOS_CAPS, nativeQr: false, nativeBarcode: false },
    transport: { chunkSize: 20, delayMs: 20, withResponse: true },
    feedAfter: 4,
    cut: true
  }
};
var DEFAULT_PROFILE = "escpos-58";
function listProfiles() {
  return Object.values(PROFILES).map((p) => ({
    id: p.id,
    label: p.label,
    renderer: p.renderer,
    paperWidth: p.paperWidth,
    columns: p.columns
  }));
}
function resolveProfile(profile, overrides = {}) {
  var _a, _b, _c, _d;
  const base = typeof profile === "string" ? PROFILES[profile] : profile;
  if (!base) {
    throw new Error(
      `Perfil desconocido: ${JSON.stringify(profile)}. Disponibles: ${Object.keys(PROFILES).join(", ")}`
    );
  }
  const merged = {
    ...base,
    ...overrides,
    capabilities: { ...base.capabilities, ...(_a = overrides.capabilities) != null ? _a : {} },
    transport: { ...base.transport, ...(_b = overrides.transport) != null ? _b : {} },
    raster: base.raster || overrides.raster ? { ...(_c = base.raster) != null ? _c : {}, ...(_d = overrides.raster) != null ? _d : {} } : void 0
  };
  if (merged.renderer !== "escpos" && merged.renderer !== "raster") {
    throw new Error(`Renderizador desconocido: ${merged.renderer}`);
  }
  return merged;
}
function defineProfile(id, base, overrides = {}) {
  const profile = resolveProfile(base, { ...overrides, id });
  PROFILES[id] = profile;
  return profile;
}
function detectProfile(tree, hints = {}) {
  var _a;
  const services = (tree != null ? tree : []).map((s) => s.service);
  if (services.includes(CAT_SERVICE)) {
    return {
      profile: "cat-58",
      confident: true,
      reason: `Expone el servicio ${CAT_SERVICE.slice(4, 8)} con la caracter\xEDstica ${CAT_WRITE.slice(4, 8)}: es una \xABcat printer\xBB y solo entiende mapas de bits.`
    };
  }
  const name = String((_a = hints.name) != null ? _a : "").toUpperCase();
  if (/^(GB0[123]|GT01|YT01|MX(0[5689]|10)|MXTP|X5)/.test(name)) {
    return {
      profile: "cat-58",
      confident: false,
      reason: `El nombre anunciado (${hints.name}) es de un modelo \xABcat printer\xBB conocido, aunque no se ha visto el servicio ae30.`
    };
  }
  return {
    profile: DEFAULT_PROFILE,
    confident: false,
    reason: "No se ha detectado firma de cat printer; se asume ESC/POS de 58 mm. Si imprime basura o no imprime nada, prueba otro perfil."
  };
}

// src/codepage.js
var CP437_HIGH = "\xC7\xFC\xE9\xE2\xE4\xE0\xE5\xE7\xEA\xEB\xE8\xEF\xEE\xEC\xC4\xC5\xC9\xE6\xC6\xF4\xF6\xF2\xFB\xF9\xFF\xD6\xDC\xA2\xA3\xA5\u20A7\u0192\xE1\xED\xF3\xFA\xF1\xD1\xAA\xBA\xBF\u2310\xAC\xBD\xBC\xA1\xAB\xBB\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xDF\u0393\u03C0\u03A3\u03C3\xB5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xB1\u2265\u2264\u2320\u2321\xF7\u2248\xB0\u2219\xB7\u221A\u207F\xB2\u25A0 ";
var CP850_HIGH = "\xC7\xFC\xE9\xE2\xE4\xE0\xE5\xE7\xEA\xEB\xE8\xEF\xEE\xEC\xC4\xC5\xC9\xE6\xC6\xF4\xF6\xF2\xFB\xF9\xFF\xD6\xDC\xF8\xA3\xD8\xD7\u0192\xE1\xED\xF3\xFA\xF1\xD1\xAA\xBA\xBF\xAE\xAC\xBD\xBC\xA1\xAB\xBB\u2591\u2592\u2593\u2502\u2524\xC1\xC2\xC0\xA9\u2563\u2551\u2557\u255D\xA2\xA5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xE3\xC3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xA4\xF0\xD0\xCA\xCB\xC8\u0131\xCD\xCE\xCF\u2518\u250C\u2588\u2584\xA6\xCC\u2580\xD3\xDF\xD4\xD2\xF5\xD5\xB5\xFE\xDE\xDA\xDB\xD9\xFD\xDD\xAF\xB4\xAD\xB1\u2017\xBE\xB6\xA7\xF7\xB8\xB0\xA8\xB7\xB9\xB3\xB2\u25A0 ";
var CP858_HIGH = CP850_HIGH.slice(0, 213 - 128) + "\u20AC" + CP850_HIGH.slice(213 - 128 + 1);
var TRANSLIT = {
  \u00E1: "a",
  \u00E9: "e",
  \u00ED: "i",
  \u00F3: "o",
  \u00FA: "u",
  \u00FC: "u",
  \u00E0: "a",
  \u00E8: "e",
  \u00EC: "i",
  \u00F2: "o",
  \u00F9: "u",
  \u00E2: "a",
  \u00EA: "e",
  \u00EE: "i",
  \u00F4: "o",
  \u00FB: "u",
  \u00E4: "a",
  \u00EB: "e",
  \u00EF: "i",
  \u00F6: "o",
  \u00E3: "a",
  \u00F5: "o",
  \u00E5: "a",
  \u00F1: "n",
  \u00E7: "c",
  \u00FD: "y",
  \u00FF: "y",
  \u00C1: "A",
  \u00C9: "E",
  \u00CD: "I",
  \u00D3: "O",
  \u00DA: "U",
  \u00DC: "U",
  \u00C0: "A",
  \u00C8: "E",
  \u00CC: "I",
  \u00D2: "O",
  \u00D9: "U",
  \u00C2: "A",
  \u00CA: "E",
  \u00CE: "I",
  \u00D4: "O",
  \u00DB: "U",
  \u00C4: "A",
  \u00CB: "E",
  \u00CF: "I",
  \u00D6: "O",
  \u00C3: "A",
  \u00D5: "O",
  \u00C5: "A",
  \u00D1: "N",
  \u00C7: "C",
  \u00DD: "Y",
  \u00AA: "a",
  \u00BA: "o",
  "\xBF": "?",
  "\xA1": "!",
  "\u20AC": "EUR",
  "\xA3": "GBP",
  "\xA5": "JPY",
  "\u201C": '"',
  "\u201D": '"',
  "\u2018": "'",
  "\u2019": "'",
  "\u2013": "-",
  "\u2014": "-",
  "\u2026": "...",
  "\xB7": ".",
  "\xB0": "o",
  "\xB1": "+/-",
  "\xBD": "1/2",
  "\xBC": "1/4",
  "\xBE": "3/4",
  " ": " ",
  "\xAD": "-"
};
var CODEPAGES = {
  CP437: { escT: 0, table: CP437_HIGH, label: "CP437 \u2014 USA / est\xE1ndar" },
  CP850: { escT: 2, table: CP850_HIGH, label: "CP850 \u2014 Latin-1 multiling\xFCe" },
  CP858: { escT: 19, table: CP858_HIGH, label: "CP858 \u2014 CP850 + \u20AC" },
  ASCII: { escT: null, table: null, label: "Transliterar a ASCII (sin acentos)" },
  UTF8: { escT: null, table: null, label: "UTF-8 crudo (sin traducir)" }
};
var DEFAULT_CODEPAGE = "CP850";
var reverseCache = /* @__PURE__ */ new Map();
function reverseMap(cpKey) {
  var _a;
  if (reverseCache.has(cpKey)) return reverseCache.get(cpKey);
  const table = (_a = CODEPAGES[cpKey]) == null ? void 0 : _a.table;
  const map = /* @__PURE__ */ new Map();
  if (table) {
    for (let i = 0; i < table.length; i++) map.set(table[i], 128 + i);
  }
  reverseCache.set(cpKey, map);
  return map;
}
function encodeText(str, cpKey = DEFAULT_CODEPAGE) {
  if (cpKey === "UTF8") {
    return { bytes: new TextEncoder().encode(str), unmapped: [] };
  }
  const translitOnly = cpKey === "ASCII";
  const map = translitOnly ? /* @__PURE__ */ new Map() : reverseMap(cpKey);
  const out = [];
  const unmapped = /* @__PURE__ */ new Set();
  for (const ch of str) {
    const code = ch.codePointAt(0);
    if (code < 128) {
      out.push(code);
      continue;
    }
    const mapped = map.get(ch);
    if (mapped !== void 0) {
      out.push(mapped);
      continue;
    }
    const alt = TRANSLIT[ch];
    if (alt !== void 0) {
      for (const c of alt) out.push(c.charCodeAt(0));
      if (!translitOnly) unmapped.add(ch);
      continue;
    }
    out.push(63);
    unmapped.add(ch);
  }
  return { bytes: new Uint8Array(out), unmapped: [...unmapped] };
}

// src/bytes.js
function chunkBytes(bytes, size) {
  const out = [];
  for (let i = 0; i < bytes.length; i += size) {
    out.push(bytes.subarray(i, i + size));
  }
  return out;
}
function concatBytes(parts) {
  const total = parts.reduce((n, p) => n + p.length, 0);
  const out = new Uint8Array(total);
  let offset = 0;
  for (const p of parts) {
    out.set(p, offset);
    offset += p.length;
  }
  return out;
}
function hexDump(bytes, opts = {}) {
  var _a, _b;
  const perRow = (_a = opts.perRow) != null ? _a : 16;
  const limit = (_b = opts.limit) != null ? _b : Infinity;
  const view = bytes.length > limit ? bytes.subarray(0, limit) : bytes;
  const rows = [];
  for (let i = 0; i < view.length; i += perRow) {
    const slice = view.subarray(i, i + perRow);
    const hex = [...slice].map((b) => b.toString(16).padStart(2, "0")).join(" ").padEnd(perRow * 3 - 1, " ");
    const ascii = [...slice].map((b) => b >= 32 && b < 127 ? String.fromCharCode(b) : ".").join("");
    rows.push(`${i.toString(16).padStart(6, "0")}  ${hex}  |${ascii}|`);
  }
  if (bytes.length > view.length) {
    rows.push(`\u2026 ${bytes.length - view.length} byte(s) m\xE1s`);
  }
  return rows.join("\n");
}
function parseHex(str) {
  const cleaned = String(str).replace(/0x/gi, "").replace(/[\s,;:\r\n]+/g, "");
  if (!cleaned.length) return new Uint8Array(0);
  if (!/^[0-9a-f]+$/i.test(cleaned)) {
    throw new Error("El hex contiene caracteres no v\xE1lidos");
  }
  if (cleaned.length % 2 !== 0) {
    throw new Error("El hex debe tener un n\xFAmero par de d\xEDgitos");
  }
  const out = new Uint8Array(cleaned.length / 2);
  for (let i = 0; i < out.length; i++) {
    out[i] = parseInt(cleaned.substr(i * 2, 2), 16);
  }
  return out;
}
function toBytes(value) {
  if (value == null) return new Uint8Array(0);
  if (value instanceof Uint8Array) return value;
  if (value instanceof ArrayBuffer) return new Uint8Array(value);
  if (ArrayBuffer.isView(value)) return new Uint8Array(value.buffer, value.byteOffset, value.byteLength);
  if (Array.isArray(value)) return Uint8Array.from(value);
  if (typeof value === "string") return parseHex(value);
  throw new Error("No se puede interpretar el valor como bytes");
}
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// src/protocol/escpos.js
var ESC = 27;
var GS = 29;
var LF = 10;
var ALIGN = { left: 0, center: 1, right: 2 };
var EscPos = class {
  /**
   * @param {{codepage?: string}} opts
   */
  constructor(opts = {}) {
    var _a;
    this.codepage = (_a = opts.codepage) != null ? _a : DEFAULT_CODEPAGE;
    this.chunks = [];
    this.unmapped = /* @__PURE__ */ new Set();
  }
  // -- primitivas ------------------------------------------------------------
  raw(...bytes) {
    this.chunks.push(Uint8Array.from(bytes.flat()));
    return this;
  }
  bytes(arr) {
    if (arr && arr.length) this.chunks.push(arr instanceof Uint8Array ? arr : Uint8Array.from(arr));
    return this;
  }
  /** Texto sin salto de línea. */
  text(str) {
    const { bytes, unmapped } = encodeText(String(str != null ? str : ""), this.codepage);
    unmapped.forEach((c) => this.unmapped.add(c));
    this.chunks.push(bytes);
    return this;
  }
  /** Texto con salto de línea. */
  line(str = "") {
    return this.text(str).raw(LF);
  }
  lines(arr) {
    for (const l of arr) this.line(l);
    return this;
  }
  // -- estado de la impresora ------------------------------------------------
  /** ESC @ — reinicia todos los modos. Debe ir siempre primero. */
  init() {
    var _a;
    this.raw(ESC, 64);
    const escT = (_a = CODEPAGES[this.codepage]) == null ? void 0 : _a.escT;
    if (escT !== null && escT !== void 0) this.raw(ESC, 116, escT);
    return this;
  }
  /** ESC a n */
  align(which) {
    var _a;
    const n = typeof which === "number" ? which : (_a = ALIGN[which]) != null ? _a : 0;
    return this.raw(ESC, 97, n);
  }
  /** ESC E n */
  bold(on = true) {
    return this.raw(ESC, 69, on ? 1 : 0);
  }
  /** ESC - n  (0 = off, 1 = fino, 2 = grueso) */
  underline(n = 1) {
    return this.raw(ESC, 45, n);
  }
  /** ESC M n  (0 = fuente A 12x24, 1 = fuente B 9x17) */
  font(which = "A") {
    return this.raw(ESC, 77, which === "B" ? 1 : 0);
  }
  /** GS ! n — multiplicador de ancho y alto, 1..8 cada uno. */
  size(width = 1, height = 1) {
    const w = Math.min(8, Math.max(1, width)) - 1;
    const h = Math.min(8, Math.max(1, height)) - 1;
    return this.raw(GS, 33, w << 4 | h);
  }
  /** GS B n — blanco sobre negro. */
  invert(on = true) {
    return this.raw(GS, 66, on ? 1 : 0);
  }
  /** Vuelve a texto normal: sin negrita, sin subrayado, tamaño 1x1, izquierda. */
  reset() {
    return this.bold(false).underline(0).invert(false).size(1, 1).align("left");
  }
  /** ESC d n — avanza n líneas. */
  feed(n = 1) {
    return this.raw(ESC, 100, Math.min(255, Math.max(0, n)));
  }
  /** GS V m — 0 = corte total, 1 = corte parcial. */
  cut(partial = false) {
    return this.raw(GS, 86, partial ? 1 : 0);
  }
  /** ESC p — pulso al cajón portamonedas. */
  drawerKick(pin = 0) {
    return this.raw(ESC, 112, pin ? 1 : 0, 25, 250);
  }
  // -- códigos gráficos ------------------------------------------------------
  /**
   * QR nativo vía GS ( k. La impresora lo genera sola, así que sale más nítido
   * y ocupa muchísimos menos bytes que mandarlo como imagen. No todos los
   * modelos lo soportan: los que no, se declaran con `nativeQr: false` en el
   * perfil y el renderizador dibuja la matriz.
   *
   * @param {string} data
   * @param {{size?: number, ecc?: 0|1|2|3}} opts  size 1..16, ecc L/M/Q/H
   */
  qr(data, opts = {}) {
    var _a, _b;
    const size = Math.min(16, Math.max(1, (_a = opts.size) != null ? _a : 6));
    const ecc = 48 + ((_b = opts.ecc) != null ? _b : 1);
    const bytes = new TextEncoder().encode(data);
    this.raw(GS, 40, 107, 4, 0, 49, 65, 50, 0);
    this.raw(GS, 40, 107, 3, 0, 49, 67, size);
    this.raw(GS, 40, 107, 3, 0, 49, 69, ecc);
    const len = bytes.length + 3;
    this.raw(GS, 40, 107, len & 255, len >> 8 & 255, 49, 80, 48);
    this.chunks.push(bytes);
    this.raw(GS, 40, 107, 3, 0, 49, 81, 48);
    return this;
  }
  /**
   * Código de barras vía GS k. Para Code128 se prefija el selector de juego B
   * ("{B"), que es el que admite dígitos y mayúsculas/minúsculas.
   */
  barcode(data, opts = {}) {
    var _a, _b, _c, _d;
    const type = (_a = opts.type) != null ? _a : 73;
    const height = (_b = opts.height) != null ? _b : 60;
    const width = (_c = opts.width) != null ? _c : 2;
    const hri = (_d = opts.hri) != null ? _d : 2;
    this.raw(GS, 104, height);
    this.raw(GS, 119, width);
    this.raw(GS, 72, hri);
    const encoded = new TextEncoder().encode(data);
    const payload = type === 73 ? [123, 66, ...encoded] : [...encoded];
    this.raw(GS, 107, type, payload.length);
    this.chunks.push(Uint8Array.from(payload));
    return this;
  }
  /**
   * Imagen raster monocroma vía GS v 0, a partir de un mapa de bits ya
   * empaquetado MSB primero (que es lo contrario que el protocolo cat).
   *
   * @param {Uint8Array} bitmap bytesPerRow * height
   * @param {number} widthDots
   * @param {number} height
   */
  rasterBitmap(bitmap, widthDots, height) {
    const bytesPerRow = Math.ceil(widthDots / 8);
    this.raw(
      GS,
      118,
      48,
      0,
      bytesPerRow & 255,
      bytesPerRow >> 8 & 255,
      height & 255,
      height >> 8 & 255
    );
    this.chunks.push(bitmap);
    return this;
  }
  // -- salida ----------------------------------------------------------------
  get length() {
    return this.chunks.reduce((n, c) => n + c.length, 0);
  }
  build() {
    return concatBytes(this.chunks);
  }
};

// src/barcode.js
var PATTERNS = [
  "212222",
  "222122",
  "222221",
  "121223",
  "121322",
  "131222",
  "121232",
  "131232",
  "132212",
  "221213",
  "221312",
  "231212",
  "112232",
  "122132",
  "122231",
  "113222",
  "123122",
  "123221",
  "223211",
  "221132",
  "221231",
  "213212",
  "223112",
  "312131",
  "311222",
  "321122",
  "321221",
  "312212",
  "322112",
  "322211",
  "212123",
  "212321",
  "232121",
  "111323",
  "131123",
  "131321",
  "112313",
  "132113",
  "132311",
  "211313",
  "231113",
  "231311",
  "112133",
  "112331",
  "132131",
  "113123",
  "113321",
  "133121",
  "313121",
  "211331",
  "231131",
  "213113",
  "213311",
  "213131",
  "311123",
  "311321",
  "331121",
  "312113",
  "312311",
  "332111",
  "314111",
  "221411",
  "431111",
  "111224",
  "111422",
  "121124",
  "121421",
  "141122",
  "141221",
  "112214",
  "112412",
  "122114",
  "122411",
  "142112",
  "142211",
  "241211",
  "221114",
  "413111",
  "241112",
  "134111",
  "111242",
  "121142",
  "121241",
  "114212",
  "124112",
  "124211",
  "411212",
  "421112",
  "421211",
  "212141",
  "214121",
  "412121",
  "111143",
  "111341",
  "131141",
  "114113",
  "114311",
  "411113",
  "411311",
  "113141",
  "114131",
  "311141",
  "411131",
  "211412",
  "211214",
  "211232",
  "2331112"
];
var START_B = 104;
var STOP = 106;
function encodeCode128(text) {
  const str = String(text != null ? text : "");
  const codes = [START_B];
  for (const ch of str) {
    const code = ch.codePointAt(0);
    if (code < 32 || code > 127) {
      throw new Error(
        `Code128B no admite el car\xE1cter ${JSON.stringify(ch)} (only ASCII 32-127). Transforma el dato antes de imprimirlo, o usa un QR.`
      );
    }
    codes.push(code - 32);
  }
  let checksum = START_B;
  for (let i = 1; i < codes.length; i++) checksum += codes[i] * i;
  codes.push(checksum % 103);
  codes.push(STOP);
  const modules = [];
  for (const code of codes) {
    const pattern = PATTERNS[code];
    for (let i = 0; i < pattern.length; i++) {
      const run = Number(pattern[i]);
      const dark = i % 2 === 0;
      for (let n = 0; n < run; n++) modules.push(dark ? 1 : 0);
    }
  }
  return { bars: Uint8Array.from(modules), width: modules.length, text: str };
}
function isCode128Compatible(text) {
  return [...String(text != null ? text : "")].every((ch) => {
    const c = ch.codePointAt(0);
    return c >= 32 && c <= 127;
  });
}
var SYMBOLOGIES = {
  code128: { escposType: 73, label: "Code128" },
  code39: { escposType: 69, label: "Code39" },
  ean13: { escposType: 67, label: "EAN-13" },
  ean8: { escposType: 68, label: "EAN-8" },
  upca: { escposType: 65, label: "UPC-A" },
  itf: { escposType: 70, label: "ITF" }
};

// src/qr.js
var ECC_LEVELS = {
  L: { index: 0, formatBits: 1, label: "L \u2014 7 %" },
  M: { index: 1, formatBits: 0, label: "M \u2014 15 %" },
  Q: { index: 2, formatBits: 3, label: "Q \u2014 25 %" },
  H: { index: 3, formatBits: 2, label: "H \u2014 30 %" }
};
var ECC_CODEWORDS_PER_BLOCK = [
  // 0   1   2   3   4   5   6   7   8   9  10  11  12  13  14  15  16  17  18  19  20  21  22  23  24  25  26  27  28  29  30  31  32  33  34  35  36  37  38  39  40
  [-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
  // L
  [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
  // M
  [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
  // Q
  [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]
  // H
];
var NUM_ERROR_CORRECTION_BLOCKS = [
  // 0   1   2   3   4   5   6   7   8   9  10  11  12  13  14  15  16  17  18  19  20  21  22  23  24  25  26  27  28  29  30  31  32  33  34  35  36  37  38  39  40
  [-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25],
  // L
  [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49],
  // M
  [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68],
  // Q
  [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81]
  // H
];
var MIN_VERSION = 1;
var MAX_VERSION = 40;
var PENALTY_N1 = 3;
var PENALTY_N2 = 3;
var PENALTY_N3 = 40;
var PENALTY_N4 = 10;
function gfMul(a, b) {
  let result = 0;
  for (let i = 7; i >= 0; i--) {
    result = (result << 1 ^ (result >>> 7) * 285) & 255;
    result ^= (b >>> i & 1) * a;
    result &= 255;
  }
  return result;
}
function rsGenerator(degree) {
  const result = new Uint8Array(degree);
  result[degree - 1] = 1;
  let root = 1;
  for (let i = 0; i < degree; i++) {
    for (let j = 0; j < degree; j++) {
      result[j] = gfMul(result[j], root);
      if (j + 1 < degree) result[j] ^= result[j + 1];
    }
    root = gfMul(root, 2);
  }
  return result;
}
function rsRemainder(data, generator) {
  const result = new Uint8Array(generator.length);
  for (const byte of data) {
    const factor = byte ^ result[0];
    result.copyWithin(0, 1);
    result[result.length - 1] = 0;
    for (let i = 0; i < result.length; i++) {
      result[i] ^= gfMul(generator[i], factor);
    }
  }
  return result;
}
function rawDataModules(version) {
  let result = (16 * version + 128) * version + 64;
  if (version >= 2) {
    const numAlign = Math.floor(version / 7) + 2;
    result -= (25 * numAlign - 10) * numAlign - 55;
    if (version >= 7) result -= 36;
  }
  return result;
}
function dataCodewords(version, eccIndex) {
  return Math.floor(rawDataModules(version) / 8) - ECC_CODEWORDS_PER_BLOCK[eccIndex][version] * NUM_ERROR_CORRECTION_BLOCKS[eccIndex][version];
}
function alignmentPositions(version) {
  if (version === 1) return [];
  const numAlign = Math.floor(version / 7) + 2;
  const size = version * 4 + 17;
  const step = version === 32 ? 26 : Math.ceil((version * 4 + 4) / (numAlign * 2 - 2)) * 2;
  const result = [6];
  for (let pos = size - 7; result.length < numAlign; pos -= step) {
    result.splice(1, 0, pos);
  }
  return result.sort((a, b) => a - b);
}
var Matrix = class {
  constructor(size) {
    this.size = size;
    this.modules = new Uint8Array(size * size);
    this.reserved = new Uint8Array(size * size);
  }
  get(x, y) {
    return this.modules[y * this.size + x];
  }
  set(x, y, dark, isFunction = false) {
    this.modules[y * this.size + x] = dark ? 1 : 0;
    if (isFunction) this.reserved[y * this.size + x] = 1;
  }
  isReserved(x, y) {
    return this.reserved[y * this.size + x] === 1;
  }
};
function drawFinder(m, cx, cy) {
  for (let dy = -4; dy <= 4; dy++) {
    for (let dx = -4; dx <= 4; dx++) {
      const x = cx + dx;
      const y = cy + dy;
      if (x < 0 || x >= m.size || y < 0 || y >= m.size) continue;
      const dist = Math.max(Math.abs(dx), Math.abs(dy));
      m.set(x, y, dist !== 2 && dist <= 3, true);
    }
  }
}
function drawAlignment(m, cx, cy) {
  for (let dy = -2; dy <= 2; dy++) {
    for (let dx = -2; dx <= 2; dx++) {
      m.set(cx + dx, cy + dy, Math.max(Math.abs(dx), Math.abs(dy)) !== 1, true);
    }
  }
}
function drawFunctionPatterns(m, version) {
  const { size } = m;
  for (let i = 0; i < size; i++) {
    m.set(6, i, i % 2 === 0, true);
    m.set(i, 6, i % 2 === 0, true);
  }
  drawFinder(m, 3, 3);
  drawFinder(m, size - 4, 3);
  drawFinder(m, 3, size - 4);
  const pos = alignmentPositions(version);
  for (let i = 0; i < pos.length; i++) {
    for (let j = 0; j < pos.length; j++) {
      const corner = i === 0 && j === 0 || i === 0 && j === pos.length - 1 || i === pos.length - 1 && j === 0;
      if (!corner) drawAlignment(m, pos[i], pos[j]);
    }
  }
  reserveFormatArea(m);
  if (version >= 7) reserveVersionArea(m);
  m.set(8, size - 8, true, true);
}
function reserveFormatArea(m) {
  const { size } = m;
  for (let i = 0; i <= 8; i++) {
    if (i !== 6) {
      m.set(i, 8, false, true);
      m.set(8, i, false, true);
    }
  }
  for (let i = 0; i < 8; i++) {
    m.set(size - 1 - i, 8, false, true);
    m.set(8, size - 1 - i, false, true);
  }
}
function reserveVersionArea(m) {
  const { size } = m;
  for (let i = 0; i < 18; i++) {
    const a = Math.floor(i / 3);
    const b = size - 11 + i % 3;
    m.set(a, b, false, true);
    m.set(b, a, false, true);
  }
}
function formatBits(eccFormatBits, mask) {
  const data = eccFormatBits << 3 | mask;
  let rem = data;
  for (let i = 0; i < 10; i++) rem = rem << 1 ^ (rem >>> 9) * 1335;
  return (data << 10 | rem) ^ 21522;
}
function drawFormat(m, eccFormatBits, mask) {
  const bits = formatBits(eccFormatBits, mask);
  const { size } = m;
  for (let i = 0; i <= 5; i++) m.set(8, i, bit(bits, i), true);
  m.set(8, 7, bit(bits, 6), true);
  m.set(8, 8, bit(bits, 7), true);
  m.set(7, 8, bit(bits, 8), true);
  for (let i = 9; i < 15; i++) m.set(14 - i, 8, bit(bits, i), true);
  for (let i = 0; i < 8; i++) m.set(size - 1 - i, 8, bit(bits, i), true);
  for (let i = 8; i < 15; i++) m.set(8, size - 15 + i, bit(bits, i), true);
  m.set(8, size - 8, true, true);
}
function drawVersion(m, version) {
  if (version < 7) return;
  let rem = version;
  for (let i = 0; i < 12; i++) rem = rem << 1 ^ (rem >>> 11) * 7973;
  const bits = version << 12 | rem;
  const { size } = m;
  for (let i = 0; i < 18; i++) {
    const dark = bit(bits, i);
    const a = Math.floor(i / 3);
    const b = size - 11 + i % 3;
    m.set(a, b, dark, true);
    m.set(b, a, dark, true);
  }
}
var bit = (value, i) => (value >>> i & 1) === 1;
function drawCodewords(m, data) {
  const { size } = m;
  let i = 0;
  for (let right = size - 1; right >= 1; right -= 2) {
    if (right === 6) right = 5;
    for (let vert = 0; vert < size; vert++) {
      for (let j = 0; j < 2; j++) {
        const x = right - j;
        const upward = (right + 1 & 2) === 0;
        const y = upward ? size - 1 - vert : vert;
        if (m.isReserved(x, y)) continue;
        if (i < data.length * 8) {
          m.set(x, y, bit(data[i >>> 3], 7 - (i & 7)));
          i++;
        }
      }
    }
  }
}
var MASK_FN = [
  (x, y) => (x + y) % 2 === 0,
  (x, y) => y % 2 === 0,
  (x) => x % 3 === 0,
  (x, y) => (x + y) % 3 === 0,
  (x, y) => (Math.floor(x / 3) + Math.floor(y / 2)) % 2 === 0,
  (x, y) => x * y % 2 + x * y % 3 === 0,
  (x, y) => (x * y % 2 + x * y % 3) % 2 === 0,
  (x, y) => ((x + y) % 2 + x * y % 3) % 2 === 0
];
function applyMask(m, mask) {
  const fn = MASK_FN[mask];
  for (let y = 0; y < m.size; y++) {
    for (let x = 0; x < m.size; x++) {
      if (m.isReserved(x, y)) continue;
      if (fn(x, y)) m.modules[y * m.size + x] ^= 1;
    }
  }
}
function penalty(m) {
  const { size } = m;
  let score = 0;
  for (let axis = 0; axis < 2; axis++) {
    for (let a = 0; a < size; a++) {
      const line = new Uint8Array(size);
      for (let b = 0; b < size; b++) {
        line[b] = axis === 0 ? m.get(b, a) : m.get(a, b);
      }
      let runLength = 1;
      for (let b = 1; b <= size; b++) {
        if (b < size && line[b] === line[b - 1]) {
          runLength++;
        } else {
          if (runLength >= 5) score += PENALTY_N1 + (runLength - 5);
          runLength = 1;
        }
      }
      for (let b = 0; b + 11 <= size; b++) {
        const w = line.subarray(b, b + 11);
        if (matches(w, [1, 0, 1, 1, 1, 0, 1, 0, 0, 0, 0]) || matches(w, [0, 0, 0, 0, 1, 0, 1, 1, 1, 0, 1])) {
          score += PENALTY_N3;
        }
      }
    }
  }
  for (let y = 0; y < size - 1; y++) {
    for (let x = 0; x < size - 1; x++) {
      const v = m.get(x, y);
      if (v === m.get(x + 1, y) && v === m.get(x, y + 1) && v === m.get(x + 1, y + 1)) {
        score += PENALTY_N2;
      }
    }
  }
  let dark = 0;
  for (const v of m.modules) dark += v;
  const total = size * size;
  const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
  score += Math.max(0, k) * PENALTY_N4;
  return score;
}
function matches(window2, pattern) {
  for (let i = 0; i < pattern.length; i++) {
    if (window2[i] !== pattern[i]) return false;
  }
  return true;
}
var BitBuffer = class {
  constructor() {
    this.bits = [];
  }
  push(value, length) {
    for (let i = length - 1; i >= 0; i--) this.bits.push(value >>> i & 1);
  }
  get length() {
    return this.bits.length;
  }
  toBytes(byteLength) {
    const out = new Uint8Array(byteLength);
    for (let i = 0; i < this.bits.length; i++) {
      if (this.bits[i]) out[i >>> 3] |= 128 >>> (i & 7);
    }
    return out;
  }
};
var charCountBits = (version) => version <= 9 ? 8 : 16;
function interleave(dataBytes, version, eccIndex) {
  const numBlocks = NUM_ERROR_CORRECTION_BLOCKS[eccIndex][version];
  const eccPerBlock = ECC_CODEWORDS_PER_BLOCK[eccIndex][version];
  const totalCodewords = Math.floor(rawDataModules(version) / 8);
  const shortBlocks = numBlocks - totalCodewords % numBlocks;
  const shortLength = Math.floor(totalCodewords / numBlocks) - eccPerBlock;
  const generator = rsGenerator(eccPerBlock);
  const blocks = [];
  let offset = 0;
  for (let i = 0; i < numBlocks; i++) {
    const length = shortLength + (i < shortBlocks ? 0 : 1);
    const data = dataBytes.subarray(offset, offset + length);
    offset += length;
    blocks.push({ data, ecc: rsRemainder(data, generator) });
  }
  const out = new Uint8Array(totalCodewords);
  let k = 0;
  for (let i = 0; i <= shortLength; i++) {
    for (let b = 0; b < blocks.length; b++) {
      if (i < blocks[b].data.length) out[k++] = blocks[b].data[i];
    }
  }
  for (let i = 0; i < eccPerBlock; i++) {
    for (const block of blocks) out[k++] = block.ecc[i];
  }
  return out;
}
function encodeQr(text, opts = {}) {
  var _a, _b, _c, _d;
  const requested = (_b = ECC_LEVELS[(_a = opts.ecc) != null ? _a : "M"]) != null ? _b : ECC_LEVELS.M;
  const minVersion = clampVersion((_c = opts.minVersion) != null ? _c : MIN_VERSION);
  const maxVersion = clampVersion((_d = opts.maxVersion) != null ? _d : MAX_VERSION);
  const payload = new TextEncoder().encode(String(text != null ? text : ""));
  let version = minVersion;
  for (; ; version++) {
    if (version > maxVersion) {
      throw new Error(
        `El dato no cabe en un QR (${payload.length} bytes con correcci\xF3n ${requested.label.slice(0, 1)}; m\xE1ximo en la versi\xF3n ${maxVersion})`
      );
    }
    const capacity = dataCodewords(version, requested.index) * 8;
    const needed = 4 + charCountBits(version) + payload.length * 8;
    if (needed <= capacity) break;
  }
  let ecc = requested;
  if (opts.boost !== false) {
    for (const key of ["H", "Q", "M"]) {
      const candidate = ECC_LEVELS[key];
      if (candidate.index <= requested.index) continue;
      const capacity = dataCodewords(version, candidate.index) * 8;
      const needed = 4 + charCountBits(version) + payload.length * 8;
      if (needed <= capacity) {
        ecc = candidate;
        break;
      }
    }
  }
  const capacityBytes = dataCodewords(version, ecc.index);
  const buffer = new BitBuffer();
  buffer.push(4, 4);
  buffer.push(payload.length, charCountBits(version));
  for (const byte of payload) buffer.push(byte, 8);
  const capacityBits = capacityBytes * 8;
  buffer.push(0, Math.min(4, capacityBits - buffer.length));
  buffer.push(0, (8 - buffer.length % 8) % 8);
  for (let pad = 236; buffer.length < capacityBits; pad ^= 236 ^ 17) {
    buffer.push(pad, 8);
  }
  const codewords = interleave(buffer.toBytes(capacityBytes), version, ecc.index);
  const m = new Matrix(version * 4 + 17);
  drawFunctionPatterns(m, version);
  drawVersion(m, version);
  drawCodewords(m, codewords);
  let mask = opts.mask;
  if (mask === void 0 || mask === null) {
    let best = Infinity;
    for (let candidate = 0; candidate < 8; candidate++) {
      applyMask(m, candidate);
      drawFormat(m, ecc.formatBits, candidate);
      const score = penalty(m);
      if (score < best) {
        best = score;
        mask = candidate;
      }
      applyMask(m, candidate);
    }
  }
  applyMask(m, mask);
  drawFormat(m, ecc.formatBits, mask);
  return {
    size: m.size,
    version,
    ecc: Object.keys(ECC_LEVELS).find((k) => ECC_LEVELS[k] === ecc),
    mask,
    modules: m.modules,
    get(x, y) {
      if (x < 0 || y < 0 || x >= m.size || y >= m.size) return false;
      return m.modules[y * m.size + x] === 1;
    }
  };
}
function clampVersion(v) {
  return Math.min(MAX_VERSION, Math.max(MIN_VERSION, Math.floor(v)));
}
function qrCapacityBytes(version, ecc = "M") {
  var _a;
  const v = clampVersion(version);
  const level = (_a = ECC_LEVELS[ecc]) != null ? _a : ECC_LEVELS.M;
  const bits = dataCodewords(v, level.index) * 8 - 4 - charCountBits(v);
  return Math.max(0, Math.floor(bits / 8));
}
var customEncoder = null;
function setQrEncoder(fn) {
  customEncoder = fn;
}
function qrEncode(text, opts) {
  return (customEncoder != null ? customEncoder : encodeQr)(text, opts);
}

// src/render/bitmap.js
function createPixmap(width, height) {
  return { data: new Uint8Array(width * height), width, height };
}
function blit(dst, src, x0, y0) {
  for (let y = 0; y < src.height; y++) {
    const dy = y0 + y;
    if (dy < 0 || dy >= dst.height) continue;
    for (let x = 0; x < src.width; x++) {
      const dx = x0 + x;
      if (dx < 0 || dx >= dst.width) continue;
      if (src.data[y * src.width + x]) dst.data[dy * dst.width + dx] = 1;
    }
  }
}
function offsetFor(align, width, total) {
  if (align === "center") return Math.max(0, Math.floor((total - width) / 2));
  if (align === "right") return Math.max(0, total - width);
  return 0;
}
function qrPixmap(value, opts = {}) {
  var _a, _b, _c;
  const ecc = (_a = opts.ecc) != null ? _a : "M";
  const quiet = (_b = opts.quietZone) != null ? _b : 4;
  const qr = qrEncode(value, { ecc });
  let moduleSize = Math.max(1, Math.floor((_c = opts.moduleSize) != null ? _c : 6));
  if (opts.maxWidth) {
    const needed = (qr.size + quiet * 2) * moduleSize;
    if (needed > opts.maxWidth) {
      moduleSize = Math.max(1, Math.floor(opts.maxWidth / (qr.size + quiet * 2)));
    }
  }
  const side = (qr.size + quiet * 2) * moduleSize;
  const out = createPixmap(side, side);
  for (let y = 0; y < qr.size; y++) {
    for (let x = 0; x < qr.size; x++) {
      if (!qr.get(x, y)) continue;
      const px = (x + quiet) * moduleSize;
      const py = (y + quiet) * moduleSize;
      for (let dy = 0; dy < moduleSize; dy++) {
        const row = (py + dy) * side;
        for (let dx = 0; dx < moduleSize; dx++) out.data[row + px + dx] = 1;
      }
    }
  }
  return { ...out, version: qr.version, ecc: qr.ecc, moduleSize };
}
function barcodePixmap(value, opts = {}) {
  var _a, _b, _c;
  const { bars } = encodeCode128(value);
  const quiet = (_a = opts.quietZone) != null ? _a : 10;
  const height = Math.max(1, Math.floor((_b = opts.height) != null ? _b : 60));
  let moduleWidth = Math.max(1, Math.floor((_c = opts.moduleWidth) != null ? _c : 2));
  if (opts.maxWidth) {
    const needed = (bars.length + quiet * 2) * moduleWidth;
    if (needed > opts.maxWidth) {
      moduleWidth = Math.max(1, Math.floor(opts.maxWidth / (bars.length + quiet * 2)));
    }
  }
  const width = (bars.length + quiet * 2) * moduleWidth;
  const out = createPixmap(width, height);
  for (let i = 0; i < bars.length; i++) {
    if (!bars[i]) continue;
    const x0 = (i + quiet) * moduleWidth;
    for (let y = 0; y < height; y++) {
      const row = y * width;
      for (let dx = 0; dx < moduleWidth; dx++) out.data[row + x0 + dx] = 1;
    }
  }
  return out;
}
function packMsbFirst(pixmap) {
  const bytesPerRow = Math.ceil(pixmap.width / 8);
  const out = new Uint8Array(bytesPerRow * pixmap.height);
  for (let y = 0; y < pixmap.height; y++) {
    for (let x = 0; x < pixmap.width; x++) {
      if (pixmap.data[y * pixmap.width + x]) {
        out[y * bytesPerRow + (x >> 3)] |= 128 >> (x & 7);
      }
    }
  }
  return { bitmap: out, bytesPerRow };
}
function packLsbFirstRows(pixmap) {
  const bytesPerRow = Math.ceil(pixmap.width / 8);
  const rows = [];
  for (let y = 0; y < pixmap.height; y++) {
    const row = new Uint8Array(bytesPerRow);
    for (let x = 0; x < pixmap.width; x++) {
      if (pixmap.data[y * pixmap.width + x]) row[x >> 3] |= 1 << (x & 7);
    }
    rows.push(row);
  }
  return rows;
}
function rgbaToPixmap(rgba, width, height, opts = {}) {
  var _a, _b;
  const threshold = Number((_a = opts.threshold) != null ? _a : 128);
  const useFloyd = ((_b = opts.dither) != null ? _b : "floyd") === "floyd";
  const gray = new Float32Array(width * height);
  for (let i = 0, p = 0; p < gray.length; i += 4, p++) {
    const alpha = rgba[i + 3];
    gray[p] = alpha === 0 ? 255 : 0.299 * rgba[i] + 0.587 * rgba[i + 1] + 0.114 * rgba[i + 2];
  }
  const out = createPixmap(width, height);
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const p = y * width + x;
      const old = gray[p];
      const black = old < threshold;
      out.data[p] = black !== !!opts.invert ? 1 : 0;
      if (!useFloyd) continue;
      const err = old - (black ? 0 : 255);
      if (x + 1 < width) gray[p + 1] += err * 7 / 16;
      if (y + 1 < height) {
        if (x > 0) gray[p + width - 1] += err * 3 / 16;
        gray[p + width] += err * 5 / 16;
        if (x + 1 < width) gray[p + width + 1] += err * 1 / 16;
      }
    }
  }
  return out;
}
function pixmapToRgba(pixmap) {
  const rgba = new Uint8ClampedArray(pixmap.width * pixmap.height * 4);
  for (let p = 0; p < pixmap.data.length; p++) {
    const v = pixmap.data[p] ? 0 : 255;
    rgba[p * 4] = v;
    rgba[p * 4 + 1] = v;
    rgba[p * 4 + 2] = v;
    rgba[p * 4 + 3] = 255;
  }
  return rgba;
}
function inkRatio(pixmap) {
  let ink = 0;
  for (const v of pixmap.data) ink += v;
  return ink / (pixmap.width * pixmap.height);
}

// src/render/canvas.js
var factory = null;
function setCanvasFactory(fn) {
  factory = fn;
}
function canRasterize() {
  return !!factory || typeof OffscreenCanvas !== "undefined" || typeof document !== "undefined" && !!document.createElement;
}
function createCanvas(width, height) {
  if (factory) return factory(width, height);
  if (typeof OffscreenCanvas !== "undefined") {
    return new OffscreenCanvas(Math.max(1, width), Math.max(1, height));
  }
  if (typeof document !== "undefined") {
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, width);
    canvas.height = Math.max(1, height);
    return canvas;
  }
  throw new Error(
    "No hay canvas disponible. El renderizador raster (cat printer, im\xE1genes) necesita navegador, o un canvas inyectado con setCanvasFactory()."
  );
}
function measuringContext() {
  return createCanvas(8, 8).getContext("2d");
}
async function loadPixmap(source, opts = {}) {
  const { width, height, rgba } = await toRgba(source, opts.maxWidth);
  return rgbaToPixmap(rgba, width, height, opts);
}
async function toRgba(source, maxWidth) {
  var _a, _b;
  if (source == null) throw new Error("image.source vac\xEDo");
  if (typeof ImageData !== "undefined" && source instanceof ImageData) {
    if (!maxWidth || source.width <= maxWidth) {
      return { width: source.width, height: source.height, rgba: source.data };
    }
    const canvas = createCanvas(source.width, source.height);
    canvas.getContext("2d").putImageData(source, 0, 0);
    return drawScaled(canvas, source.width, source.height, maxWidth);
  }
  const bitmap = await decode(source);
  const w = (_a = bitmap.width) != null ? _a : bitmap.naturalWidth;
  const h = (_b = bitmap.height) != null ? _b : bitmap.naturalHeight;
  if (!w || !h) throw new Error("La imagen no tiene dimensiones utilizables");
  return drawScaled(bitmap, w, h, maxWidth);
}
async function decode(source) {
  if (typeof source === "string") {
    if (typeof createImageBitmap === "function" && typeof fetch === "function") {
      const response = await fetch(source);
      if (!response.ok) throw new Error(`No se pudo cargar la imagen (${response.status})`);
      return createImageBitmap(await response.blob());
    }
    return loadImageElement(source);
  }
  if (typeof Blob !== "undefined" && source instanceof Blob) {
    if (typeof createImageBitmap === "function") return createImageBitmap(source);
    return loadImageElement(URL.createObjectURL(source));
  }
  return source;
}
function loadImageElement(src) {
  return new Promise((resolve, reject) => {
    if (typeof Image === "undefined") {
      reject(new Error("No hay forma de decodificar la imagen en este entorno"));
      return;
    }
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`No se pudo cargar la imagen: ${src.slice(0, 80)}`));
    img.src = src;
  });
}
function drawScaled(drawable, width, height, maxWidth) {
  const scale = maxWidth && width > maxWidth ? maxWidth / width : 1;
  const w = Math.max(1, Math.round(width * scale));
  const h = Math.max(1, Math.round(height * scale));
  const canvas = createCanvas(w, h);
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, w, h);
  ctx.drawImage(drawable, 0, 0, w, h);
  return { width: w, height: h, rgba: ctx.getImageData(0, 0, w, h).data };
}

// src/render/escpos.js
async function renderEscPos(doc, profile = "escpos-58") {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  const p = resolveProfile(profile);
  const normalized = normalizeDocument(doc);
  const d = normalized.defaults;
  const codepage = (_b = (_a = d.codepage) != null ? _a : p.codepage) != null ? _b : "CP850";
  const font = (_d = (_c = d.font) != null ? _c : p.font) != null ? _d : "A";
  const baseCols = (_e = d.columns) != null ? _e : p.columns;
  const warnings = [];
  const out = new EscPos({ codepage });
  out.init().font(font === "B" ? "B" : "A");
  const state = { align: "left", bold: false, underline: 0, invert: false, w: 1, h: 1 };
  const setAlign = (align) => {
    if (state.align === align) return;
    out.align(align);
    state.align = align;
  };
  const setStyle = (style = {}) => {
    var _a2;
    const bold = !!style.bold;
    const underline = (_a2 = style.underline) != null ? _a2 : 0;
    const invert = !!style.invert;
    if (state.bold !== bold) {
      out.bold(bold);
      state.bold = bold;
    }
    if (state.underline !== underline) {
      out.underline(underline);
      state.underline = underline;
    }
    if (state.invert !== invert) {
      out.invert(invert);
      state.invert = invert;
    }
  };
  const setSize = (size) => {
    var _a2, _b2;
    const w = (_a2 = size == null ? void 0 : size.w) != null ? _a2 : 1;
    const h = (_b2 = size == null ? void 0 : size.h) != null ? _b2 : 1;
    if (state.w !== w || state.h !== h) {
      out.size(w, h);
      state.w = w;
      state.h = h;
    }
  };
  const emitPixmap = (pixmap, align) => {
    const canvasWidth = Math.ceil(p.dots / 8) * 8;
    if (pixmap.width >= canvasWidth) {
      const { bitmap: bitmap2 } = packMsbFirst(pixmap);
      out.rasterBitmap(bitmap2, pixmap.width, pixmap.height);
      return;
    }
    const framed = createPixmap(canvasWidth, pixmap.height);
    blit(framed, pixmap, offsetFor(align, pixmap.width, canvasWidth), 0);
    const { bitmap } = packMsbFirst(framed);
    out.rasterBitmap(bitmap, framed.width, framed.height);
  };
  for (const node of normalized.body) {
    const align = (_f = node.align) != null ? _f : "left";
    const cols = Math.max(4, Math.floor(baseCols / ((_h = (_g = node.size) == null ? void 0 : _g.w) != null ? _h : 1)));
    switch (node.type) {
      case "text": {
        setAlign(align);
        setStyle(node.style);
        setSize(node.size);
        const lines = node.wrap === false ? [String(node.value).slice(0, cols)] : wrapText(node.value, cols);
        out.lines(lines);
        break;
      }
      case "row": {
        setAlign("left");
        setStyle(node.style);
        setSize(node.size);
        out.lines(layoutPair(node.left, node.right, cols, node.gap));
        break;
      }
      case "columns": {
        setAlign("left");
        setStyle(node.style);
        setSize(node.size);
        out.lines(layoutRow(node.cells, cols, { gap: node.gap }));
        break;
      }
      case "table": {
        setAlign("left");
        setSize(node.size);
        if (node.header) {
          setStyle({ ...(_i = node.style) != null ? _i : {}, bold: (_k = (_j = node.style) == null ? void 0 : _j.bold) != null ? _k : true });
          out.lines(layoutRow(mergeSpec(node.header, node.columns), cols, { gap: node.gap }));
        }
        setStyle(node.style);
        for (const row of node.rows) {
          out.lines(layoutRow(mergeSpec(row, node.columns), cols, { gap: node.gap }));
        }
        break;
      }
      case "rule": {
        setAlign("left");
        setStyle(node.style);
        setSize(node.size);
        for (let i = 0; i < node.thickness; i++) out.line(divider(cols, node.char));
        break;
      }
      case "space":
        if (node.lines > 0) out.feed(node.lines);
        break;
      case "qr": {
        if (p.capabilities.nativeQr) {
          setAlign(align);
          setStyle({});
          setSize({ w: 1, h: 1 });
          out.qr(node.value, { size: node.size, ecc: eccToEscPos(node.ecc) });
        } else {
          const pixmap = qrPixmap(node.value, {
            moduleSize: node.size,
            ecc: node.ecc,
            maxWidth: p.dots
          });
          setStyle({});
          setSize({ w: 1, h: 1 });
          emitPixmap(pixmap, align);
        }
        break;
      }
      case "barcode": {
        const symbology = String(node.symbology).toLowerCase();
        if (p.capabilities.nativeBarcode && SYMBOLOGIES[symbology]) {
          setAlign(align);
          setStyle({});
          setSize({ w: 1, h: 1 });
          out.barcode(node.value, {
            type: SYMBOLOGIES[symbology].escposType,
            height: node.height,
            width: node.moduleWidth,
            hri: node.hri
          });
        } else if (symbology === "code128" && isCode128Compatible(node.value)) {
          const pixmap = barcodePixmap(node.value, {
            height: node.height,
            moduleWidth: node.moduleWidth,
            maxWidth: p.dots
          });
          setStyle({});
          setSize({ w: 1, h: 1 });
          emitPixmap(pixmap, align);
          if (node.hri === 2 || node.hri === 3) {
            setAlign(align);
            out.line(alignText(node.value, cols, align));
          }
        } else {
          warnings.push(
            `No se pudo imprimir el c\xF3digo de barras "${node.value}": la impresora no genera ${symbology} y la librer\xEDa solo sabe dibujar Code128. Se imprime el valor como texto.`
          );
          setAlign(align);
          out.line(alignText(node.value, cols, align));
        }
        break;
      }
      case "image": {
        if (!p.capabilities.image) {
          warnings.push("El perfil declara que la impresora no admite im\xE1genes; el nodo image se ha omitido.");
          break;
        }
        if (!canRasterize()) {
          warnings.push("No hay canvas disponible: el nodo image se ha omitido.");
          break;
        }
        try {
          const pixmap = await loadPixmap(node.source, {
            maxWidth: Math.min(p.dots, (_l = node.width) != null ? _l : p.dots),
            dither: node.dither,
            threshold: node.threshold
          });
          setStyle({});
          setSize({ w: 1, h: 1 });
          emitPixmap(pixmap, align);
        } catch (err) {
          warnings.push(`No se pudo imprimir la imagen: ${err.message}`);
        }
        break;
      }
      case "cut":
        if (p.capabilities.cut) {
          out.cut(node.partial);
        } else {
          warnings.push("El perfil no tiene cuchilla; el nodo cut se ha ignorado.");
        }
        break;
      case "pulse":
        if (p.capabilities.drawer) out.drawerKick(node.pin);
        break;
      case "raw":
        if (node.escpos) out.bytes(toBytes(node.escpos));
        break;
      default:
        break;
    }
  }
  out.reset();
  const feed = (_n = (_m = d.feedAfter) != null ? _m : p.feedAfter) != null ? _n : 0;
  if (feed > 0) out.feed(feed);
  const hasExplicitCut = normalized.body.some((n) => n.type === "cut");
  const shouldCut = (_o = d.cut) != null ? _o : p.cut;
  if (!hasExplicitCut && shouldCut && p.capabilities.cut) out.cut(false);
  const unmapped = [...out.unmapped];
  if (unmapped.length) {
    warnings.push(
      `La code page ${codepage} no cubre estos caracteres: ${unmapped.join(" ")}. Se han transliterado o sustituido por "?". Prueba con CP858 o con el perfil raster.`
    );
  }
  return { bytes: out.build(), warnings, unmapped };
}
function mergeSpec(cells, columns) {
  if (!(columns == null ? void 0 : columns.length)) return cells;
  return cells.map((cell, i) => ({ ...columns[i], ...cell }));
}
function eccToEscPos(ecc) {
  var _a;
  return (_a = { L: 0, M: 1, Q: 2, H: 3 }[ecc]) != null ? _a : 1;
}

// src/render/raster.js
var MONO = 'ui-monospace, "Cascadia Mono", Menlo, Consolas, "Courier New", monospace';
function fitMonoSize(ctx, columns, usable, maxSize = 30) {
  const probe = "0".repeat(columns);
  for (let size = maxSize; size >= 7; size -= 0.5) {
    ctx.font = `${size}px ${MONO}`;
    if (ctx.measureText(probe).width <= usable) return size;
  }
  return 7;
}
async function composeRaster(doc, profile = "cat-58") {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  if (!canRasterize()) {
    throw new Error(
      "El renderizador raster necesita un canvas. En Node, inyecta uno con setCanvasFactory() antes de llamar a print()."
    );
  }
  const p = resolveProfile(profile);
  const normalized = normalizeDocument(doc);
  const d = normalized.defaults;
  const r = (_a = p.raster) != null ? _a : {};
  const width = p.dots;
  const margin = Math.max(0, (_b = r.margin) != null ? _b : 6);
  const usable = width - margin * 2;
  const baseCols = (_c = d.columns) != null ? _c : p.columns;
  const warnings = [];
  const probe = measuringContext();
  const base = fitMonoSize(probe, baseCols, usable);
  const lineHeight = Math.round(base * 1.32);
  const ops = [];
  let height = Math.round(base * 0.6);
  const pushLines = (lines, node) => {
    var _a2, _b2, _c2, _d2, _e2, _f2;
    const sw = (_b2 = (_a2 = node.size) == null ? void 0 : _a2.w) != null ? _b2 : 1;
    const sh = (_d2 = (_c2 = node.size) == null ? void 0 : _c2.h) != null ? _d2 : 1;
    const lh = lineHeight * sh;
    ops.push({
      kind: "lines",
      lines,
      lh,
      sw,
      sh,
      align: (_e2 = node.align) != null ? _e2 : "left",
      style: (_f2 = node.style) != null ? _f2 : {}
    });
    height += lh * lines.length;
  };
  const pushPixmap = (pixmap2, align) => {
    ops.push({ kind: "pixmap", pixmap: pixmap2, align });
    height += pixmap2.height;
  };
  for (const node of normalized.body) {
    const cols = Math.max(4, Math.floor(baseCols / ((_e = (_d = node.size) == null ? void 0 : _d.w) != null ? _e : 1)));
    switch (node.type) {
      case "text":
        pushLines(
          node.wrap === false ? [String(node.value).slice(0, cols)] : wrapText(node.value, cols),
          node
        );
        break;
      case "row":
        pushLines(layoutPair(node.left, node.right, cols, node.gap), { ...node, align: "left" });
        break;
      case "columns":
        pushLines(layoutRow(node.cells, cols, { gap: node.gap }), { ...node, align: "left" });
        break;
      case "table":
        if (node.header) {
          pushLines(
            layoutRow(mergeSpec2(node.header, node.columns), cols, { gap: node.gap }),
            { ...node, align: "left", style: { ...(_f = node.style) != null ? _f : {}, bold: (_h = (_g = node.style) == null ? void 0 : _g.bold) != null ? _h : true } }
          );
        }
        for (const row of node.rows) {
          pushLines(layoutRow(mergeSpec2(row, node.columns), cols, { gap: node.gap }), { ...node, align: "left" });
        }
        break;
      case "rule": {
        const sh = (_j = (_i = node.size) == null ? void 0 : _i.h) != null ? _j : 1;
        const lh = lineHeight * sh;
        if (node.char === "-" || node.char === "=") {
          ops.push({ kind: "rule", lh, thickness: node.thickness, double: node.char === "=" });
          height += lh * node.thickness;
        } else {
          pushLines(Array.from({ length: node.thickness }, () => divider(cols, node.char)), node);
        }
        break;
      }
      case "space": {
        const px = lineHeight * node.lines;
        ops.push({ kind: "space", lh: px });
        height += px;
        break;
      }
      case "qr": {
        const pixmap2 = qrPixmap(node.value, {
          moduleSize: node.size,
          ecc: node.ecc,
          maxWidth: usable
        });
        pushPixmap(pixmap2, (_k = node.align) != null ? _k : "center");
        break;
      }
      case "barcode": {
        if (!isCode128Compatible(node.value) || String(node.symbology).toLowerCase() !== "code128") {
          warnings.push(
            `El c\xF3digo de barras "${node.value}" no se puede dibujar (${node.symbology}); se imprime como texto.`
          );
          pushLines([String(node.value)], { ...node, align: (_l = node.align) != null ? _l : "center" });
          break;
        }
        const pixmap2 = barcodePixmap(node.value, {
          height: node.height,
          moduleWidth: node.moduleWidth,
          maxWidth: usable
        });
        pushPixmap(pixmap2, (_m = node.align) != null ? _m : "center");
        if (node.hri === 2 || node.hri === 3) {
          pushLines([node.value], { ...node, align: (_n = node.align) != null ? _n : "center" });
        }
        break;
      }
      case "image":
        try {
          const pixmap2 = await loadPixmap(node.source, {
            maxWidth: Math.min(usable, (_o = node.width) != null ? _o : usable),
            dither: node.dither,
            threshold: node.threshold
          });
          pushPixmap(pixmap2, (_p = node.align) != null ? _p : "center");
        } catch (err) {
          warnings.push(`No se pudo dibujar la imagen: ${err.message}`);
        }
        break;
      case "cut":
        if (!warnings.some((w) => w.startsWith("Sin cuchilla"))) {
          warnings.push("Sin cuchilla: los nodos cut se ignoran, hay que cortar el papel a mano.");
        }
        break;
      case "pulse":
      case "raw":
        break;
      default:
        break;
    }
  }
  height += Math.round(base * 0.8);
  const canvas = createCanvas(width, Math.max(1, Math.round(height)));
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, width, canvas.height);
  ctx.textBaseline = "alphabetic";
  let y = Math.round(base * 0.6);
  for (const op of ops) {
    if (op.kind === "space") {
      y += op.lh;
      continue;
    }
    if (op.kind === "rule") {
      const thin = Math.max(1, Math.round(base / 12));
      for (let i = 0; i < op.thickness; i++) {
        ctx.fillStyle = "#000";
        const cy = y + Math.floor((op.lh - thin) / 2);
        if (op.double) {
          ctx.fillRect(margin, cy - thin, usable, thin);
          ctx.fillRect(margin, cy + thin, usable, thin);
        } else {
          ctx.fillRect(margin, cy, usable, thin);
        }
        y += op.lh;
      }
      continue;
    }
    if (op.kind === "pixmap") {
      drawPixmap(ctx, op.pixmap, margin + offsetFor(op.align, op.pixmap.width, usable), y);
      y += op.pixmap.height;
      continue;
    }
    const weight = op.style.bold ? "700 " : "500 ";
    for (const text of op.lines) {
      ctx.save();
      ctx.scale(op.sw, op.sh);
      ctx.font = `${weight}${base}px ${MONO}`;
      const textWidth = ctx.measureText(text).width * op.sw;
      const x = margin + offsetFor(op.align, textWidth, usable);
      const baseline = y + op.lh * 0.78;
      if (op.style.invert) {
        ctx.fillStyle = "#000";
        ctx.fillRect(x / op.sw, y / op.sh, textWidth / op.sw, op.lh / op.sh);
        ctx.fillStyle = "#fff";
      } else {
        ctx.fillStyle = "#000";
      }
      ctx.fillText(text, x / op.sw, baseline / op.sh);
      ctx.restore();
      if (op.style.underline) {
        ctx.fillStyle = "#000";
        const thick = op.style.underline === 2 ? 3 : 1;
        ctx.fillRect(x, y + op.lh * 0.88, textWidth, thick);
      }
      y += op.lh;
    }
  }
  const { data } = ctx.getImageData(0, 0, width, canvas.height);
  const pixmap = rgbaToPixmap(data, width, canvas.height, {
    dither: (_q = r.dither) != null ? _q : "floyd",
    threshold: (_r = r.threshold) != null ? _r : 128
  });
  return { pixmap, warnings, width, height: canvas.height };
}
async function renderRaster(doc, profile = "cat-58") {
  var _a;
  const p = resolveProfile(profile);
  const r = (_a = p.raster) != null ? _a : {};
  const { pixmap, warnings } = await composeRaster(doc, p);
  const rows = packLsbFirstRows(pixmap);
  const ink = inkRatio(pixmap);
  if (ink > 0.45) {
    warnings.push(
      `El ${Math.round(ink * 100)} % de los puntos son negros. La impresi\xF3n ser\xE1 lenta y el cabezal puede sobrecalentarse; baja la energ\xEDa o quita fondos oscuros.`
    );
  }
  const bytes = buildCatJob(rows, {
    energy: r.energy,
    speed: r.speed,
    feedDots: r.feedDots,
    startNew: r.startNew
  });
  return { bytes, warnings, pixmap, unmapped: [] };
}
function mergeSpec2(cells, columns) {
  if (!(columns == null ? void 0 : columns.length)) return cells;
  return cells.map((cell, i) => ({ ...columns[i], ...cell }));
}
function drawPixmap(ctx, pixmap, x, y) {
  const img = ctx.createImageData(pixmap.width, pixmap.height);
  for (let p = 0; p < pixmap.data.length; p++) {
    const v = pixmap.data[p] ? 0 : 255;
    img.data[p * 4] = v;
    img.data[p * 4 + 1] = v;
    img.data[p * 4 + 2] = v;
    img.data[p * 4 + 3] = 255;
  }
  ctx.putImageData(img, Math.round(x), Math.round(y));
}

// src/render/text.js
function renderText(doc, profile = "escpos-58", opts = {}) {
  var _a, _b, _c, _d, _e, _f;
  const p = resolveProfile(profile);
  const normalized = normalizeDocument(doc);
  const marks = opts.marks !== false;
  const baseCols = (_a = normalized.defaults.columns) != null ? _a : p.columns;
  const out = [];
  const note = (text) => {
    if (marks) out.push(alignText(text, baseCols, "center"));
  };
  for (const node of normalized.body) {
    const cols = Math.max(4, Math.floor(baseCols / ((_c = (_b = node.size) == null ? void 0 : _b.w) != null ? _c : 1)));
    const align = (_d = node.align) != null ? _d : "left";
    switch (node.type) {
      case "text": {
        const lines = node.wrap === false ? [String(node.value).slice(0, cols)] : wrapText(node.value, cols);
        for (const line of lines) out.push(alignText(line, cols, align));
        break;
      }
      case "row":
        out.push(...layoutPair(node.left, node.right, cols, node.gap));
        break;
      case "columns":
        for (const line of layoutRow(node.cells, cols, { gap: node.gap })) {
          out.push(alignText(line, cols, align === "left" ? "left" : align));
        }
        break;
      case "table": {
        if (node.header) {
          const cells = mergeSpec3(node.header, node.columns);
          out.push(...layoutRow(cells, cols, { gap: node.gap }));
        }
        for (const row of node.rows) {
          const cells = mergeSpec3(row, node.columns);
          out.push(...layoutRow(cells, cols, { gap: node.gap }));
        }
        break;
      }
      case "rule":
        for (let i = 0; i < node.thickness; i++) out.push(divider(cols, node.char));
        break;
      case "space":
        for (let i = 0; i < node.lines; i++) out.push("");
        break;
      case "qr":
        note(`[ QR \xB7 ${node.ecc} ]`);
        note(truncate(node.value, baseCols));
        break;
      case "barcode":
        note(`[ ${String(node.symbology).toUpperCase()} ]`);
        if (node.hri) note(truncate(node.value, baseCols));
        break;
      case "image":
        note("[ IMAGEN ]");
        break;
      case "cut":
        note(node.partial ? "- - - - corte parcial - - - -" : "\u2500\u2500\u2500\u2500 corte \u2500\u2500\u2500\u2500");
        break;
      case "pulse":
        note("[ caj\xF3n portamonedas ]");
        break;
      case "raw":
        note("[ bytes crudos ]");
        break;
      default:
        break;
    }
  }
  const feed = (_f = (_e = normalized.defaults.feedAfter) != null ? _e : p.feedAfter) != null ? _f : 0;
  for (let i = 0; i < feed; i++) out.push("");
  return out.join("\n");
}
function mergeSpec3(cells, columns) {
  if (!(columns == null ? void 0 : columns.length)) return cells;
  return cells.map((cell, i) => ({ ...columns[i], ...cell }));
}
function truncate(text, cols) {
  const t = String(text);
  return t.length <= cols ? t : `${t.slice(0, Math.max(1, cols - 1))}\u2026`;
}

// src/printer.js
var Printer = class _Printer extends Emitter {
  /**
   * @param {{profile?: string|object, profileOverrides?: object,
   *          transport?: object, transportOptions?: object}} opts
   */
  constructor(opts = {}) {
    var _a, _b, _c, _d;
    super();
    this.profile = resolveProfile((_a = opts.profile) != null ? _a : DEFAULT_PROFILE, (_b = opts.profileOverrides) != null ? _b : {});
    this.transport = (_c = opts.transport) != null ? _c : null;
    this.transportOptions = { ...(_d = opts.transportOptions) != null ? _d : {} };
    this.state = "disconnected";
    this.busy = false;
    this.lastDeviceState = null;
    this._unbind = [];
    if (this.transport) this._bindTransport(this.transport);
  }
  // -- transporte ------------------------------------------------------------
  /** Sustituye el transporte (por ejemplo al pasar de BLE a serie). */
  setTransport(transport) {
    for (const off of this._unbind) off();
    this._unbind = [];
    this.transport = transport;
    if (transport) this._bindTransport(transport);
    return this;
  }
  _bindTransport(transport) {
    this._unbind.push(
      transport.on("log", (e) => this.emit("log", e)),
      transport.on("progress", (e) => this.emit("progress", e)),
      transport.on("status", (e) => {
        this.state = e.state;
        this.emit("status", e);
      })
    );
  }
  get isConnected() {
    var _a;
    return !!((_a = this.transport) == null ? void 0 : _a.isConnected);
  }
  /** Perfil activo, ya resuelto. Solo lectura: usa `setProfile` para cambiarlo. */
  setProfile(profile, overrides = {}) {
    this.profile = resolveProfile(profile, overrides);
    this.emit("profile", this.profile);
    return this.profile;
  }
  // -- ciclo de vida ---------------------------------------------------------
  /**
   * Abre el selector del navegador. **Debe llamarse desde un gesto del usuario.**
   * @param {object} [opts] se pasa tal cual al transporte
   */
  async requestDevice(opts = {}) {
    if (!this.transport) throw new Error("No hay transporte configurado");
    if (typeof this.transport.requestDevice === "function") {
      return this.transport.requestDevice(opts);
    }
    return this.transport.requestPort(opts);
  }
  /**
   * Conecta y prepara la salida.
   *
   * Tras conectar por BLE se intenta detectar el perfil a partir del árbol
   * GATT. Si detecta una cat printer y el perfil activo es ESC/POS, lo avisa
   * por el evento `detect` en vez de cambiarlo por su cuenta: quien decide es
   * la app, que es la que sabe si el usuario ya eligió a mano.
   *
   * @param {{autoProfile?: boolean}} [opts] autoProfile aplica la detección
   */
  async connect(opts = {}) {
    var _a, _b, _c;
    if (!this.transport) throw new Error("No hay transporte configurado");
    await this.transport.connect(
      this.transport.id === "serial" ? { baudRate: (_a = this.transportOptions.baudRate) != null ? _a : 9600 } : void 0
    );
    if (this.transport.id === "ble") {
      const detection = detectProfile(this.transport.tree, { name: this.transport.label });
      this.emit("detect", detection);
      if (opts.autoProfile && detection.profile !== this.profile.id) {
        this.setProfile(detection.profile);
        this.emit("log", {
          level: "ok",
          message: `Perfil cambiado a "${detection.profile}": ${detection.reason}`
        });
      }
      const preferred = this.profile.renderer === "raster" ? { service: CAT_SERVICE, characteristic: "0000ae01-0000-1000-8000-00805f9b34fb" } : (_b = this.transportOptions.characteristic) != null ? _b : null;
      const selected = this.transport.autoSelect(preferred);
      if (!selected) {
        throw new Error(
          "La impresora no expone ninguna caracter\xEDstica de escritura. Revisa el \xE1rbol GATT del evento \xABtree\xBB para ver qu\xE9 publica."
        );
      }
      await this._subscribeCatStatus();
    }
    return (_c = this.transport.tree) != null ? _c : null;
  }
  /** Suscripción a los avisos de estado de las cat printers (ae02). */
  async _subscribeCatStatus() {
    var _a;
    const svc = ((_a = this.transport.tree) != null ? _a : []).find((s) => s.service === CAT_SERVICE);
    if (!(svc == null ? void 0 : svc.characteristics.some((c) => c.uuid === CAT_NOTIFY))) return;
    try {
      await this.transport.subscribe(CAT_SERVICE, CAT_NOTIFY, (bytes) => {
        const state = parseDeviceState(bytes);
        this.lastDeviceState = state;
        const description = describeDeviceState(state);
        if (description) {
          this.emit("device-state", state);
          this.emit("log", { level: state.noPaper ? "warn" : "rx", message: `Estado de la impresora: ${description}` });
        }
      });
    } catch (err) {
      this.emit("log", { level: "warn", message: `No se pudo suscribir a los avisos de estado: ${err.message}` });
    }
  }
  async disconnect() {
    if (this.transport) await this.transport.disconnect();
    this.state = "disconnected";
  }
  // -- renderizado -----------------------------------------------------------
  /**
   * Convierte el documento en bytes sin enviarlos.
   *
   * Útil para previsualizar el tamaño del trabajo, para volcarlo a un archivo
   * de diagnóstico, o para mandarlo por otro canal.
   *
   * @param {object} doc
   * @returns {Promise<{bytes: Uint8Array, warnings: string[], pixmap?: object}>}
   */
  async render(doc) {
    const normalized = normalizeDocument(doc);
    return this.profile.renderer === "raster" ? renderRaster(normalized, this.profile) : renderEscPos(normalized, this.profile);
  }
  /**
   * Vista previa.
   *
   * `as: 'text'` devuelve el recibo como texto monoespaciado al ancho real; es
   * lo que conviene enseñar en una pantalla de configuración. `as: 'pixmap'`
   * devuelve los píxeles exactos que se van a imprimir, solo para perfiles
   * raster.
   *
   * @param {object} doc
   * @param {{as?: 'text'|'pixmap'}} [opts]
   */
  async preview(doc, opts = {}) {
    const normalized = normalizeDocument(doc);
    if (opts.as === "pixmap") {
      if (this.profile.renderer !== "raster") {
        throw new Error("La vista previa en p\xEDxeles solo existe para perfiles raster");
      }
      return composeRaster(normalized, this.profile);
    }
    return renderText(normalized, this.profile);
  }
  // -- impresión -------------------------------------------------------------
  /**
   * Renderiza y envía.
   *
   * @param {object} doc
   * @param {{onProgress?: Function}} [opts]
   * @returns {Promise<{sent: number, warnings: string[], bytes: number}>}
   */
  async print(doc, opts = {}) {
    const { bytes, warnings } = await this.render(doc);
    await this._send(bytes, opts);
    for (const warning of warnings) {
      this.emit("log", { level: "warn", message: warning });
    }
    return { sent: bytes.length, bytes: bytes.length, warnings };
  }
  /** Envía bytes ya construidos. La escotilla para casos que la API no cubre. */
  async sendRaw(bytes, opts = {}) {
    await this._send(bytes instanceof Uint8Array ? bytes : Uint8Array.from(bytes), opts);
    return bytes.length;
  }
  async _send(bytes, opts = {}) {
    var _a, _b;
    if (!((_a = this.transport) == null ? void 0 : _a.isConnected)) {
      throw new Error("No hay conexi\xF3n con la impresora");
    }
    if (!bytes.length) return 0;
    if (this.busy) {
      throw new Error("Ya hay un trabajo de impresi\xF3n en curso");
    }
    this.busy = true;
    this.emit("busy", true);
    try {
      const writeOpts = { ...this.profile.transport, ...this.transportOptions };
      return await this.transport.write(bytes, writeOpts, (_b = opts.onProgress) != null ? _b : null);
    } finally {
      this.busy = false;
      this.emit("busy", false);
    }
  }
  // -- acciones sueltas ------------------------------------------------------
  /** Avanza papel. En raster el parámetro son puntos; en ESC/POS, líneas. */
  async feed(amount = 3) {
    if (this.profile.renderer === "raster") {
      return this.sendRaw(buildCatFeed(amount > 32 ? amount : amount * 32));
    }
    return this.sendRaw(new EscPos({ codepage: this.profile.codepage }).feed(amount).build());
  }
  /** Corta el papel, si la impresora tiene cuchilla. */
  async cut(partial = false) {
    if (!this.profile.capabilities.cut) {
      this.emit("log", { level: "warn", message: "Esta impresora no tiene cuchilla." });
      return 0;
    }
    return this.sendRaw(new EscPos({ codepage: this.profile.codepage }).cut(partial).build());
  }
  /** Abre el cajón portamonedas. */
  async openDrawer(pin = 0) {
    if (!this.profile.capabilities.drawer) {
      this.emit("log", { level: "warn", message: "Este perfil no admite caj\xF3n portamonedas." });
      return 0;
    }
    return this.sendRaw(new EscPos({ codepage: this.profile.codepage }).drawerKick(pin).build());
  }
  // -- configuración persistible --------------------------------------------
  /**
   * Ajustes serializables, para guardar en localStorage o en el backend.
   *
   * **No incluye permiso de acceso al dispositivo.** Web Bluetooth no permite
   * reconectar a una impresora sin que el usuario la vuelva a elegir en el
   * selector, salvo que esté activo el flag de permisos persistentes de Chrome.
   * Lo que se guarda es qué impresora era y cómo hablarle, para que al volver a
   * elegirla no haya que reconfigurar nada.
   */
  toConfig() {
    var _a, _b, _c, _d;
    return {
      v: 1,
      profile: this.profile.id,
      profileOverrides: {
        columns: this.profile.columns,
        codepage: this.profile.codepage,
        feedAfter: this.profile.feedAfter,
        cut: this.profile.cut,
        ...this.profile.raster ? { raster: { ...this.profile.raster } } : {}
      },
      transport: (_b = (_a = this.transport) == null ? void 0 : _a.id) != null ? _b : null,
      transportOptions: { ...this.transportOptions },
      device: (_d = (_c = this.transport) == null ? void 0 : _c.deviceInfo) != null ? _d : null
    };
  }
  /**
   * Reconstruye desde `toConfig()`. El transporte se pasa aparte porque es un
   * objeto vivo, no algo serializable.
   *
   * @param {object} config
   * @param {{transport?: object}} [deps]
   */
  static fromConfig(config, deps = {}) {
    var _a, _b, _c, _d, _e;
    const printer = new _Printer({
      profile: (_a = config == null ? void 0 : config.profile) != null ? _a : DEFAULT_PROFILE,
      profileOverrides: (_b = config == null ? void 0 : config.profileOverrides) != null ? _b : {},
      transport: (_c = deps.transport) != null ? _c : null,
      transportOptions: (_d = config == null ? void 0 : config.transportOptions) != null ? _d : {}
    });
    printer.savedDevice = (_e = config == null ? void 0 : config.device) != null ? _e : null;
    return printer;
  }
};

// src/transport/ble.js
function expandUuid(short) {
  const s = String(short).trim().toLowerCase();
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(s)) return s;
  if (/^(0x)?[0-9a-f]{1,8}$/.test(s)) {
    const hex = s.replace(/^0x/, "").padStart(8, "0");
    return `${hex}-0000-1000-8000-00805f9b34fb`;
  }
  throw new Error(`UUID no reconocido: ${short}`);
}
var KNOWN_PRINTER_SERVICES = [
  {
    service: "000018f0-0000-1000-8000-00805f9b34fb",
    write: ["00002af1-0000-1000-8000-00805f9b34fb"],
    label: "Gen\xE9rico ESC/POS (Zjiang, Xprinter, Munbyn)"
  },
  {
    service: "0000ff00-0000-1000-8000-00805f9b34fb",
    write: [
      "0000ff02-0000-1000-8000-00805f9b34fb",
      "0000ff01-0000-1000-8000-00805f9b34fb"
    ],
    label: "Goojprt / gen\xE9ricas chinas"
  },
  {
    service: "0000ae30-0000-1000-8000-00805f9b34fb",
    write: ["0000ae01-0000-1000-8000-00805f9b34fb"],
    label: "Cat printer (protocolo gr\xE1fico propietario)"
  },
  {
    service: "0000ffe0-0000-1000-8000-00805f9b34fb",
    write: ["0000ffe1-0000-1000-8000-00805f9b34fb"],
    label: "M\xF3dulos HM-10 / JDY"
  },
  {
    service: "6e400001-b5a3-f393-e0a9-e50e24dcca9e",
    write: ["6e400002-b5a3-f393-e0a9-e50e24dcca9e"],
    label: "Nordic UART (NUS)"
  },
  {
    service: "49535343-fe7d-4ae5-8fa9-9fafd205e455",
    write: [
      "49535343-8841-43f4-a8d4-ecbe34729bb3",
      "49535343-aca3-481c-91ec-d85e28a60318"
    ],
    label: "Microchip / ISSC transparent UART"
  },
  {
    service: "e7810a71-73ae-499d-8c15-faa9aef0c3f2",
    write: ["bef8d6c9-9c21-4c9e-b632-bd58c1009f9f"],
    label: "Port\xE1tiles varias"
  },
  {
    service: "0000fee7-0000-1000-8000-00805f9b34fb",
    write: [
      "0000fec7-0000-1000-8000-00805f9b34fb",
      "0000fea1-0000-1000-8000-00805f9b34fb"
    ],
    label: "Tuya / gen\xE9ricas"
  }
];
var KNOWN_WRITE_CHARS = new Set(KNOWN_PRINTER_SERVICES.flatMap((s) => s.write));
var CHUNK_SIZES = [20, 40, 64, 100, 128, 182, 244, 512];
var BleTransport = class _BleTransport extends Emitter {
  constructor(opts = {}) {
    var _a;
    super();
    this.id = "ble";
    this.name = "Bluetooth (BLE)";
    this.device = null;
    this.server = null;
    this.characteristic = null;
    this.tree = [];
    this.autoReconnect = !!opts.autoReconnect;
    this.extraServices = (_a = opts.extraServices) != null ? _a : [];
    this._onDisconnected = this._handleDisconnect.bind(this);
  }
  _log(level, message, detail) {
    this.emit("log", { level, message, detail });
  }
  // -- disponibilidad --------------------------------------------------------
  static get supported() {
    return typeof navigator !== "undefined" && !!navigator.bluetooth;
  }
  /** Diagnóstico legible del entorno; para el panel de ajustes de la app. */
  static async availability() {
    if (typeof window === "undefined") {
      return { ok: false, reason: "No hay navegador." };
    }
    if (!window.isSecureContext) {
      return {
        ok: false,
        reason: "La p\xE1gina no est\xE1 en un contexto seguro (https:// o localhost). Chrome deja navigator.bluetooth como undefined."
      };
    }
    if (!navigator.bluetooth) {
      return {
        ok: false,
        reason: "Este navegador no implementa Web Bluetooth. Funciona en Chrome/Edge de escritorio y en Chrome para Android; no en Safari ni en ning\xFAn navegador de iOS."
      };
    }
    try {
      const hasAdapter = await navigator.bluetooth.getAvailability();
      return hasAdapter ? { ok: true, reason: "Web Bluetooth disponible y adaptador presente." } : { ok: false, reason: "Web Bluetooth existe pero no se detecta adaptador Bluetooth encendido." };
    } catch (err) {
      return { ok: true, reason: `Web Bluetooth disponible (getAvailability fall\xF3: ${err.message}).` };
    }
  }
  get isConnected() {
    var _a, _b;
    return !!((_b = (_a = this.device) == null ? void 0 : _a.gatt) == null ? void 0 : _b.connected);
  }
  get label() {
    return this.device ? this.device.name || "(sin nombre)" : null;
  }
  /** Identidad estable para guardar en los ajustes de la app. */
  get deviceInfo() {
    var _a;
    if (!this.device) return null;
    return { id: this.device.id, name: (_a = this.device.name) != null ? _a : null };
  }
  // -- selección y conexión --------------------------------------------------
  /**
   * Abre el selector de dispositivos de Chrome.
   *
   * **Tiene que llamarse desde un gesto del usuario** (un click), o Chrome lo
   * rechaza con SecurityError. En React: llámalo dentro del onClick, nunca
   * dentro de un useEffect.
   *
   * @param {{mode?: 'all'|'known'|'name', namePrefix?: string, extraServices?: string[]}} opts
   */
  async requestDevice(opts = {}) {
    var _a, _b;
    if (!_BleTransport.supported) {
      throw new Error("Web Bluetooth no est\xE1 disponible en este navegador o contexto");
    }
    const optionalServices = [.../* @__PURE__ */ new Set([
      ...KNOWN_PRINTER_SERVICES.map((s) => s.service),
      ...[...this.extraServices, ...(_a = opts.extraServices) != null ? _a : []].map(expandUuid)
    ])];
    let request;
    if (opts.mode === "known") {
      request = { filters: optionalServices.map((service) => ({ services: [service] })), optionalServices };
    } else if (opts.mode === "name" && opts.namePrefix) {
      request = { filters: [{ namePrefix: opts.namePrefix }], optionalServices };
    } else {
      request = { acceptAllDevices: true, optionalServices };
    }
    this._log("info", `Abriendo selector (modo "${(_b = opts.mode) != null ? _b : "all"}", ${optionalServices.length} servicios declarados)\u2026`);
    const device = await navigator.bluetooth.requestDevice(request);
    this.device = device;
    this._log("ok", `Dispositivo elegido: ${device.name || "(sin nombre)"} [${device.id}]`);
    return device;
  }
  /**
   * Dispositivos ya autorizados en sesiones anteriores.
   *
   * Depende de `navigator.bluetooth.getDevices()`, que en Chrome sigue detrás
   * del flag #enable-web-bluetooth-new-permissions-backend. Sin él devuelve
   * lista vacía y **no hay forma de reconectar sin que el usuario vuelva a
   * elegir la impresora en el selector**: es una decisión de privacidad de
   * Chrome, no un fallo. Tenlo en cuenta al diseñar la pantalla de ajustes.
   */
  async knownDevices() {
    var _a;
    if (!((_a = navigator.bluetooth) == null ? void 0 : _a.getDevices)) return [];
    try {
      return await navigator.bluetooth.getDevices();
    } catch (e) {
      return [];
    }
  }
  /**
   * Conecta al GATT y recorre servicios y características.
   * @returns {Promise<Array>} árbol descubierto
   */
  async connect(device = this.device) {
    if (!device) throw new Error("No hay dispositivo seleccionado");
    this.device = device;
    device.removeEventListener("gattserverdisconnected", this._onDisconnected);
    device.addEventListener("gattserverdisconnected", this._onDisconnected);
    this.emit("status", { state: "connecting", message: `Conectando a ${device.name || "dispositivo"}\u2026` });
    this.server = await device.gatt.connect();
    this._log("ok", "Servidor GATT conectado");
    await this.discover();
    this.emit("status", { state: "connected", message: `Conectado a ${device.name || "dispositivo"}` });
    return this.tree;
  }
  /**
   * Volcado del árbol GATT. Es la salida de diagnóstico más valiosa que hay:
   * deja por escrito qué UUIDs expone realmente la impresora.
   */
  async discover() {
    const services = await this.server.getPrimaryServices();
    this.tree = [];
    if (!services.length) {
      this._log(
        "warn",
        "El dispositivo no expone ning\xFAn servicio visible. Casi siempre significa que su UUID no estaba en optionalServices: a\xF1\xE1delo con extraServices y reconecta."
      );
    }
    const report = [];
    for (const service of services) {
      let characteristics = [];
      try {
        characteristics = await service.getCharacteristics();
      } catch (err) {
        this._log("warn", `No se pudieron leer las caracter\xEDsticas de ${service.uuid}: ${err.message}`);
      }
      const entry = { service: service.uuid, ref: service, characteristics: [] };
      report.push(`servicio ${service.uuid}${describe(service.uuid)}`);
      for (const ch of characteristics) {
        const props = Object.entries({
          read: ch.properties.read,
          write: ch.properties.write,
          writeNR: ch.properties.writeWithoutResponse,
          notify: ch.properties.notify,
          indicate: ch.properties.indicate
        }).filter(([, v]) => v).map(([k]) => k);
        const writable = ch.properties.write || ch.properties.writeWithoutResponse;
        entry.characteristics.push({
          uuid: ch.uuid,
          ref: ch,
          props,
          writable,
          known: KNOWN_WRITE_CHARS.has(ch.uuid)
        });
        report.push(`  \u2514 ${ch.uuid}  [${props.join(", ") || "sin propiedades"}]${writable ? " \u2190 escribible" : ""}`);
      }
      this.tree.push(entry);
    }
    this._log("info", `Descubrimiento GATT: ${services.length} servicio(s)`, report.join("\n"));
    const writables = this.writableCharacteristics();
    if (writables.length) {
      this._log("ok", `${writables.length} caracter\xEDstica(s) escribible(s) encontrada(s)`);
    } else if (services.length) {
      this._log("warn", "Ning\xFAn servicio expone caracter\xEDsticas de escritura: esta impresora no aceptar\xE1 datos por GATT.");
    }
    this.emit("tree", this.tree);
    return this.tree;
  }
  /** Lista plana de características escribibles, las conocidas primero. */
  writableCharacteristics() {
    const out = [];
    for (const svc of this.tree) {
      for (const ch of svc.characteristics) {
        if (ch.writable) out.push({ ...ch, service: svc.service });
      }
    }
    return out.sort((a, b) => Number(b.known) - Number(a.known));
  }
  /** Fija la característica de salida por UUID de servicio + característica. */
  selectCharacteristic(serviceUuid, charUuid) {
    const svc = this.tree.find((s) => s.service === serviceUuid);
    const ch = svc == null ? void 0 : svc.characteristics.find((c) => c.uuid === charUuid);
    if (!ch) throw new Error(`No se encontr\xF3 ${charUuid} en ${serviceUuid}`);
    this.characteristic = ch.ref;
    this._log("ok", `Caracter\xEDstica de salida: ${charUuid} (servicio ${serviceUuid})`);
    return ch;
  }
  /** Elige automáticamente la mejor candidata tras el descubrimiento. */
  autoSelect(preferred = null) {
    if (preferred) {
      const svc = this.tree.find((s) => s.service === preferred.service);
      const ch = svc == null ? void 0 : svc.characteristics.find((c) => c.uuid === preferred.characteristic && c.writable);
      if (ch) {
        this.characteristic = ch.ref;
        this._log("ok", `Caracter\xEDstica preferida del perfil: ${ch.uuid}`);
        return { ...ch, service: svc.service };
      }
    }
    const [best] = this.writableCharacteristics();
    if (!best) return null;
    this.characteristic = best.ref;
    this._log(
      "ok",
      `Selecci\xF3n autom\xE1tica: ${best.uuid}${best.known ? " (UUID conocido de impresora)" : " (primera escribible)"}`
    );
    return best;
  }
  /**
   * Se suscribe a una característica de notificación.
   *
   * Las cat printers informan por ae02 de falta de papel, sobrecalentamiento o
   * batería baja. Sin esto, un trabajo que no sale parece un fallo de protocolo
   * cuando en realidad la impresora está sin papel.
   */
  async subscribe(serviceUuid, charUuid, handler) {
    const svc = this.tree.find((s) => s.service === serviceUuid);
    const entry = svc == null ? void 0 : svc.characteristics.find((c) => c.uuid === charUuid);
    if (!entry) throw new Error(`No se encontr\xF3 ${charUuid}`);
    const ch = entry.ref;
    if (!ch.properties.notify && !ch.properties.indicate) {
      throw new Error("La caracter\xEDstica no admite notificaciones");
    }
    ch.addEventListener("characteristicvaluechanged", (event) => {
      const { buffer, byteOffset, byteLength } = event.target.value;
      handler(new Uint8Array(buffer, byteOffset, byteLength));
    });
    await ch.startNotifications();
    return ch;
  }
  // -- escritura -------------------------------------------------------------
  /**
   * Envía bytes troceados.
   *
   * El troceado no es opcional: el MTU por defecto de BLE deja unos 20 bytes
   * útiles por paquete, y muchas impresoras se atragantan si además no se les
   * da una pausa entre bloques.
   *
   * @param {Uint8Array} bytes
   * @param {{chunkSize?: number, delayMs?: number, withResponse?: boolean, retries?: number}} opts
   * @param {(sent: number, total: number) => void} [onProgress]
   */
  async write(bytes, opts = {}, onProgress = null) {
    var _a, _b, _c, _d;
    if (!this.isConnected) throw new Error("GATT desconectado");
    if (!this.characteristic) throw new Error("No hay caracter\xEDstica de escritura seleccionada");
    const chunkSize = (_a = opts.chunkSize) != null ? _a : 20;
    const delayMs = (_b = opts.delayMs) != null ? _b : 20;
    const retries = (_c = opts.retries) != null ? _c : 3;
    const props = (_d = this.characteristic.properties) != null ? _d : {};
    const canNoResponse = !!props.writeWithoutResponse && typeof this.characteristic.writeValueWithoutResponse === "function";
    const canResponse = !!props.write && typeof this.characteristic.writeValueWithResponse === "function";
    let useNoResponse;
    if (opts.withResponse === false) {
      useNoResponse = canNoResponse;
      if (!canNoResponse) this._log("warn", "La caracter\xEDstica no admite escritura sin respuesta; se usa con respuesta.");
    } else {
      useNoResponse = !canResponse && canNoResponse;
      if (useNoResponse) this._log("warn", "La caracter\xEDstica solo admite escritura sin respuesta; se usa ese modo.");
    }
    let size = chunkSize;
    for (; ; ) {
      try {
        return await this._writeChunks(bytes, { chunkSize: size, delayMs, retries, useNoResponse }, onProgress);
      } catch (err) {
        if (err.sentBytes === 0 && size > 20) {
          size = Math.max(20, size >> 1);
          this._log("warn", `Bloque demasiado grande para el MTU; se reintenta con ${size} bytes.`);
          continue;
        }
        throw err;
      }
    }
  }
  async _writeChunks(bytes, opts, onProgress) {
    const { chunkSize, delayMs, retries, useNoResponse } = opts;
    const chunks = chunkBytes(bytes, chunkSize);
    this._log(
      "tx",
      `Enviando ${bytes.length} bytes en ${chunks.length} bloque(s) de ${chunkSize} (${useNoResponse ? "sin respuesta" : "con respuesta"}, ${delayMs} ms de pausa)`,
      bytes
    );
    const started = now();
    let sent = 0;
    for (let i = 0; i < chunks.length; i++) {
      const payload = new Uint8Array(chunks[i]);
      let attempt = 0;
      for (; ; ) {
        try {
          if (useNoResponse) {
            await this.characteristic.writeValueWithoutResponse(payload);
          } else if (typeof this.characteristic.writeValueWithResponse === "function") {
            await this.characteristic.writeValueWithResponse(payload);
          } else {
            await this.characteristic.writeValue(payload);
          }
          break;
        } catch (err) {
          attempt += 1;
          if (attempt > retries || !this.isConnected) {
            this._log("error", `Fallo en el bloque ${i + 1}/${chunks.length} tras ${attempt} intento(s): ${err.message}`);
            err.sentBytes = sent;
            throw err;
          }
          const backoff = delayMs * 2 * attempt + 30;
          this._log("warn", `Bloque ${i + 1} fall\xF3 (${err.name}); reintento ${attempt}/${retries} en ${backoff} ms`);
          await sleep(backoff);
        }
      }
      sent += payload.length;
      if (onProgress) onProgress(sent, bytes.length);
      this.emit("progress", { sent, total: bytes.length });
      if (delayMs > 0 && i < chunks.length - 1) await sleep(delayMs);
    }
    const elapsed = Math.max(1, Math.round(now() - started));
    this._log("ok", `${sent} bytes enviados en ${elapsed} ms (${Math.round(sent / (elapsed / 1e3))} B/s)`);
    return sent;
  }
  // -- desconexión -----------------------------------------------------------
  async disconnect() {
    var _a, _b;
    this.autoReconnect = false;
    if ((_b = (_a = this.device) == null ? void 0 : _a.gatt) == null ? void 0 : _b.connected) {
      this.device.gatt.disconnect();
      this._log("info", "Desconexi\xF3n solicitada");
    }
    this.characteristic = null;
    this.tree = [];
    this.emit("tree", this.tree);
    this.emit("status", { state: "disconnected", message: "Desconectado" });
  }
  async _handleDisconnect() {
    this.characteristic = null;
    this._log("warn", "El dispositivo se desconect\xF3");
    this.emit("status", { state: "disconnected", message: "Desconectado" });
    if (!this.autoReconnect) return;
    this._log("info", "Reconexi\xF3n autom\xE1tica en 1,5 s\u2026");
    await sleep(1500);
    try {
      await this.connect(this.device);
      this.autoSelect();
    } catch (err) {
      this._log("error", `La reconexi\xF3n autom\xE1tica fall\xF3: ${err.message}`);
    }
  }
};
function describe(uuid) {
  const hit = KNOWN_PRINTER_SERVICES.find((s) => s.service === uuid);
  return hit ? `  (${hit.label})` : "";
}
function now() {
  return typeof performance !== "undefined" ? performance.now() : Date.now();
}

// src/transport/serial.js
var BAUD_RATES = [9600, 19200, 38400, 57600, 115200, 230400];
var SerialTransport = class _SerialTransport extends Emitter {
  constructor(opts = {}) {
    var _a;
    super();
    this.id = "serial";
    this.name = "Serie (COM / USB)";
    this.port = null;
    this.writer = null;
    this.baudRate = (_a = opts.baudRate) != null ? _a : 9600;
    this._info = null;
  }
  _log(level, message, detail) {
    this.emit("log", { level, message, detail });
  }
  static get supported() {
    return typeof navigator !== "undefined" && !!navigator.serial;
  }
  static async availability() {
    if (typeof window === "undefined") return { ok: false, reason: "No hay navegador." };
    if (!window.isSecureContext) {
      return { ok: false, reason: "Web Serial exige contexto seguro (https:// o localhost)." };
    }
    if (!navigator.serial) {
      return {
        ok: false,
        reason: "Este navegador no implementa Web Serial. Solo est\xE1 en Chrome/Edge de escritorio, no en Android ni en Safari."
      };
    }
    return { ok: true, reason: "Web Serial disponible." };
  }
  get isConnected() {
    return !!this.port && !!this.writer;
  }
  get label() {
    if (!this._info) return null;
    const { usbVendorId, usbProductId } = this._info;
    return usbVendorId ? `USB ${hex4(usbVendorId)}:${hex4(usbProductId)}` : "Puerto serie";
  }
  get deviceInfo() {
    return this._info ? { ...this._info } : null;
  }
  /** Abre el selector de puertos. Requiere gesto del usuario, como en BLE. */
  async requestPort() {
    if (!_SerialTransport.supported) {
      throw new Error("Web Serial no est\xE1 disponible en este navegador");
    }
    this._log("info", "Abriendo selector de puertos serie\u2026");
    const port = await navigator.serial.requestPort();
    this.port = port;
    this._info = port.getInfo();
    this._log("ok", `Puerto elegido: ${this.label}`);
    return port;
  }
  /**
   * Puertos ya autorizados en sesiones anteriores. A diferencia de BLE, Web
   * Serial sí los recuerda sin flags: se puede reconectar solo al arrancar.
   */
  async knownPorts() {
    var _a;
    if (!((_a = navigator.serial) == null ? void 0 : _a.getPorts)) return [];
    try {
      return await navigator.serial.getPorts();
    } catch (e) {
      return [];
    }
  }
  /**
   * @param {{baudRate?: number, port?: SerialPort}} opts
   */
  async connect(opts = {}) {
    var _a, _b;
    const port = (_a = opts.port) != null ? _a : this.port;
    if (!port) throw new Error("No hay puerto seleccionado");
    this.port = port;
    this._info = port.getInfo();
    const baudRate = Number((_b = opts.baudRate) != null ? _b : this.baudRate);
    this.baudRate = baudRate;
    this.emit("status", { state: "connecting", message: `Abriendo puerto a ${baudRate} baudios\u2026` });
    await port.open({
      baudRate,
      dataBits: 8,
      stopBits: 1,
      parity: "none",
      flowControl: "none",
      bufferSize: 4096
    });
    this.writer = port.writable.getWriter();
    this._log("ok", `Puerto abierto a ${baudRate} baudios (8N1, sin control de flujo)`);
    this.emit("status", { state: "connected", message: `${this.label} @ ${baudRate}` });
    return port;
  }
  /**
   * Escritura troceada. En serie el troceado importa menos que en BLE, pero un
   * buffer pequeño en la impresora se desborda igual.
   */
  async write(bytes, opts = {}, onProgress = null) {
    var _a, _b;
    if (!this.isConnected) throw new Error("El puerto no est\xE1 abierto");
    const chunkSize = (_a = opts.chunkSize) != null ? _a : 256;
    const delayMs = (_b = opts.delayMs) != null ? _b : 0;
    const chunks = chunkBytes(bytes, chunkSize);
    this._log("tx", `Enviando ${bytes.length} bytes en ${chunks.length} bloque(s) de ${chunkSize} por el puerto serie`, bytes);
    const started = now2();
    let sent = 0;
    for (let i = 0; i < chunks.length; i++) {
      await this.writer.write(new Uint8Array(chunks[i]));
      sent += chunks[i].length;
      if (onProgress) onProgress(sent, bytes.length);
      this.emit("progress", { sent, total: bytes.length });
      if (delayMs > 0 && i < chunks.length - 1) await sleep(delayMs);
    }
    const elapsed = Math.max(1, Math.round(now2() - started));
    this._log("ok", `${sent} bytes enviados en ${elapsed} ms (${Math.round(sent / (elapsed / 1e3))} B/s)`);
    return sent;
  }
  async disconnect() {
    try {
      if (this.writer) {
        await this.writer.ready.catch(() => {
        });
        this.writer.releaseLock();
        this.writer = null;
      }
      if (this.port) {
        await this.port.close();
        this._log("info", "Puerto serie cerrado");
      }
    } catch (err) {
      this._log("error", `Error al cerrar el puerto: ${err.message}`);
    } finally {
      this.writer = null;
      this.emit("status", { state: "disconnected", message: "Desconectado" });
    }
  }
};
function hex4(n) {
  return `0x${Number(n).toString(16).padStart(4, "0")}`;
}
function now2() {
  return typeof performance !== "undefined" ? performance.now() : Date.now();
}
//# sourceMappingURL=thermal-print.cjs.map
